// Mock data for frontend development
// Will be replaced with actual API calls later

// Major Categories organized into clear sections
export const majorCategories = {
  "Business": [
    "Accounting", "Business Administration", "Business Analytics", "Economics", 
    "Entrepreneurship", "Finance", "Human Resources", "International Business", 
    "Management", "Marketing", "Real Estate", "Supply Chain Management"
  ],
  "STEM": [
    "Applied Mathematics", "Astronomy", "Biochemistry", "Biology", "Biomedical Engineering",
    "Chemical Engineering", "Chemistry", "Civil Engineering", "Computer Engineering",
    "Computer Science", "Cybersecurity", "Data Science", "Electrical Engineering",
    "Environmental Engineering", "Information Technology", "Mathematics", "Mechanical Engineering",
    "Physics", "Software Engineering", "Statistics"
  ],
  "Law & Public Policy": [
    "Criminal Justice", "Criminology", "Homeland Security", "International Relations",
    "Legal Studies", "Paralegal Studies", "Political Science", "Pre-Law", 
    "Public Administration", "Public Policy"
  ],
  "Arts & Humanities": [
    "Anthropology", "Art History", "Classics", "Communications", "Comparative Literature",
    "Creative Writing", "English", "Film Studies", "Fine Arts", "Graphic Design",
    "History", "Journalism", "Languages", "Linguistics", "Media Studies", 
    "Music", "Philosophy", "Religious Studies", "Theatre", "Writing"
  ],
  "Health & Medicine": [
    "Dental Hygiene", "Exercise Science", "Health Administration", "Health Sciences",
    "Kinesiology", "Medical Technology", "Neuroscience", "Nursing", "Nutrition",
    "Occupational Therapy", "Pharmacy", "Physical Therapy", "Pre-Dental", 
    "Pre-Med", "Pre-Veterinary", "Public Health", "Radiology", "Sports Medicine"
  ],
  "Other": [
    "Agriculture", "Architecture", "Aviation", "Culinary Arts", "Early Childhood Education",
    "Education", "Environmental Science", "Environmental Studies", "Fashion Design",
    "Forestry", "Hospitality Management", "Interior Design", "Marine Biology",
    "Military Science", "Psychology", "Social Work", "Sociology", "Special Education",
    "Sports Management", "Urban Planning"
  ]
};

export const mockColleges = {
  // Ivy League & Elite Private (no in-state discount)
  "Harvard University": {
    t: 59000, h: 20000, m: 7500, f: 3000,
    a: 4,
    r: "Top 10",
    state: "Massachusetts",
    majors: ["Business & Economics", "Social Sciences", "STEM", "Humanities"]
  },
  "Stanford University": {
    t: 61000, h: 19500, m: 7600, f: 2900,
    a: 4,
    r: "Top 10",
    majors: ["Business & Economics", "STEM", "Social Sciences", "Arts & Media"]
  },
  "MIT": {
    t: 60000, h: 18500, m: 7300, f: 2800,
    a: 4,
    r: "Top 10",
    majors: ["STEM", "Business & Economics", "Social Sciences"]
  },
  "Yale University": {
    t: 60000, h: 19000, m: 7400, f: 2900,
    a: 5,
    r: "Top 10",
    majors: ["Economics", "Global Affairs", "Statistics"]
  },
  "Princeton University": {
    t: 58000, h: 18000, m: 7200, f: 2800,
    a: 4,
    r: "Top 10",
    majors: ["Economics", "Operations Research", "Public Policy"]
  },
  "Columbia University": {
    t: 65000, h: 21000, m: 7800, f: 3200,
    a: 4,
    r: "Top 10",
    majors: ["Economics", "Financial Economics", "Political Science"]
  },
  "University of Chicago": {
    t: 64000, h: 19000, m: 7600, f: 3000,
    a: 6,
    r: "Top 10",
    majors: ["Economics", "Business Economics", "Statistics"]
  },
  "Duke University": {
    t: 63000, h: 18500, m: 7500, f: 2900,
    a: 6,
    r: "Top 10",
    majors: ["Economics", "Finance", "Public Policy"]
  },
  "Northwestern University": {
    t: 62000, h: 18500, m: 7400, f: 2900,
    a: 7,
    r: "Top 10",
    majors: ["Economics", "Business Institutions", "Data Analytics"]
  },
  "UPenn": {
    t: 63000, h: 19500, m: 7600, f: 3000,
    a: 6,
    r: "Top 10",
    majors: ["Finance", "Economics", "Business Analytics"]
  },
  "Caltech": {
    t: 61000, h: 19000, m: 7400, f: 2900,
    a: 3,
    r: "Top 10",
    majors: ["Engineering", "Economics", "Applied Math", "Data Science"]
  },
  "Dartmouth College": {
    t: 62000, h: 18500, m: 7300, f: 2800,
    a: 6,
    r: "Top 10",
    majors: ["Economics", "Government", "Engineering"]
  },
  "Brown University": {
    t: 64000, h: 19500, m: 7500, f: 3000,
    a: 5,
    r: "Top 10",
    majors: ["Economics", "Applied Math", "Computer Science"]
  },
  "Cornell University": {
    t: 63000, h: 19000, m: 7400, f: 2900,
    a: 8,
    r: "Top 20",
    majors: ["Economics", "Business", "Engineering"]
  },

  // Top Private Universities
  "Rice University": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 9,
    r: "Top 20",
    majors: ["Economics", "Engineering", "Business"]
  },
  "Vanderbilt University": {
    t: 60000, h: 18500, m: 7300, f: 2900,
    a: 7,
    r: "Top 20",
    majors: ["Economics", "Finance", "Business"]
  },
  "Notre Dame": {
    t: 61000, h: 18000, m: 7200, f: 2800,
    a: 13,
    r: "Top 20",
    majors: ["Finance", "Economics", "Business"]
  },
  "Washington University St Louis": {
    t: 61000, h: 18500, m: 7300, f: 2900,
    a: 11,
    r: "Top 20",
    majors: ["Economics", "Business", "Finance"]
  },
  "Georgetown University": {
    t: 62000, h: 19500, m: 7500, f: 3000,
    a: 12,
    r: "Top 30",
    majors: ["Economics", "Finance", "Business"]
  },
  "NYU": {
    t: 60000, h: 22000, m: 8000, f: 3000,
    a: 13,
    r: "Top 30",
    majors: ["Finance", "Business", "Economics"]
  },
  "USC": {
    t: 64000, h: 21000, m: 7800, f: 3000,
    a: 12,
    r: "Top 30",
    majors: ["Finance", "Business Administration", "Economics"]
  },
  "Carnegie Mellon": {
    t: 62000, h: 19000, m: 7500, f: 2800,
    a: 11,
    r: "Top 30",
    majors: ["Economics", "Business Administration", "Statistics"]
  },
  "Emory University": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 11,
    r: "Top 30",
    majors: ["Economics", "Business", "Finance"]
  },
  "Wake Forest University": {
    t: 61000, h: 18500, m: 7300, f: 2900,
    a: 22,
    r: "Top 30",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of Rochester": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 35,
    r: "Top 40",
    majors: ["Economics", "Business", "Finance"]
  },
  "Boston College": {
    t: 63000, h: 19000, m: 7400, f: 2900,
    a: 17,
    r: "Top 40",
    majors: ["Finance", "Economics", "Business"]
  },
  "Boston University": {
    t: 61000, h: 19000, m: 7400, f: 2900,
    a: 14,
    r: "Top 40",
    majors: ["Economics", "Business Administration", "Finance"]
  },
  "Tulane University": {
    t: 61000, h: 18500, m: 7300, f: 2900,
    a: 11,
    r: "Top 40",
    majors: ["Finance", "Economics", "Business"]
  },
  "University of Miami": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 19,
    r: "Top 40",
    majors: ["Finance", "Business", "Economics"]
  },
  "Case Western Reserve": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 27,
    r: "Top 40",
    majors: ["Engineering", "Business", "Economics"]
  },
  "Lehigh University": {
    t: 59000, h: 17500, m: 7100, f: 2700,
    a: 37,
    r: "Top 40",
    majors: ["Engineering", "Business", "Economics"]
  },
  "Northeastern University": {
    t: 58000, h: 18500, m: 7300, f: 2900,
    a: 18,
    r: "Top 40",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Rensselaer Polytechnic": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 53,
    r: "Top 40",
    majors: ["Engineering", "Business", "Economics"]
  },
  "Syracuse University": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 52,
    r: "Top 40",
    majors: ["Business", "Economics", "Finance"]
  },
  "Fordham University": {
    t: 57000, h: 19000, m: 7400, f: 2900,
    a: 54,
    r: "Top 40",
    majors: ["Finance", "Business", "Economics"]
  },

  // UC System (California Public Universities) - 2024-25 Official Data
  "UCLA": {
    t: 46693, tIn: 14805, h: 18000, m: 7500, f: 1700,
    a: 9,
    r: "Top 20",
    state: "California",
    majors: ["Economics", "Business Economics", "Statistics"]
  },
  "UC Berkeley": {
    t: 46693, tIn: 14805, h: 18500, m: 7500, f: 2000,
    a: 11,
    r: "Top 20",
    state: "California",
    majors: ["Economics", "Business Administration", "Data Science"]
  },
  "UC San Diego": {
    t: 46693, tIn: 14805, h: 17000, m: 7200, f: 1800,
    a: 24,
    r: "Top 40",
    state: "California",
    majors: ["Economics", "Business", "Data Science"]
  },
  "UC Irvine": {
    t: 46693, tIn: 14805, h: 16500, m: 7000, f: 1700,
    a: 21,
    r: "Top 40",
    state: "California",
    majors: ["Economics", "Business Administration", "Finance"]
  },
  "UC Davis": {
    t: 46693, tIn: 14805, h: 17000, m: 7200, f: 1800,
    a: 37,
    r: "Top 40",
    state: "California",
    majors: ["Economics", "Business", "Finance"]
  },
  "UC Santa Barbara": {
    t: 46693, tIn: 14805, h: 17500, m: 7000, f: 1700,
    a: 26,
    r: "Top 40",
    state: "California",
    majors: ["Economics", "Statistics", "Business"]
  },
  "UC Riverside": {
    t: 46693, tIn: 14805, h: 16000, m: 6800, f: 1600,
    a: 66,
    r: "Top 40",
    state: "California",
    majors: ["Economics", "Business", "Finance"]
  },
  "UC Santa Cruz": {
    t: 46693, tIn: 14805, h: 16500, m: 6900, f: 1700,
    a: 47,
    r: "Top 40",
    state: "California",
    majors: ["Economics", "Business", "Data Science"]
  },
  "UC Merced": {
    t: 46693, tIn: 14805, h: 15500, m: 6500, f: 1500,
    a: 89,
    r: "Top 40",
    state: "California",
    majors: ["Economics", "Engineering", "Business"]
  },

  // Major State Flagships - 2024-25 Official Data
  "University of Michigan": {
    t: 57034, tIn: 17786, h: 13500, m: 5800, f: 1700,
    a: 18,
    r: "Top 30",
    state: "Michigan",
    majors: ["Finance", "Business", "Economics"]
  },
  "University of Virginia": {
    t: 55000, tIn: 19000, h: 17000, m: 6900, f: 2500,
    a: 17,
    r: "Top 30",
    state: "Virginia",
    majors: ["Commerce", "Economics", "Finance"]
  },
  "UNC Chapel Hill": {
    t: 45000, tIn: 9000, h: 16000, m: 6800, f: 2300,
    a: 19,
    r: "Top 30",
    state: "North Carolina",
    majors: ["Business Administration", "Economics", "Finance"]
  },
  "University of Florida": {
    t: 28000, tIn: 6400, h: 12000, m: 6000, f: 2000,
    a: 23,
    r: "Top 30",
    state: "Florida",
    majors: ["Finance", "Business Administration", "Economics"]
  },
  "Georgia Tech": {
    t: 42000, tIn: 12500, h: 15000, m: 6600, f: 2200,
    a: 17,
    r: "Top 40",
    state: "Georgia",
    majors: ["Industrial Engineering", "Economics", "Analytics"]
  },
  "University of Texas Austin": {
    t: 42000, tIn: 11500, h: 14500, m: 6500, f: 2300,
    a: 29,
    r: "Top 40",
    state: "Texas",
    majors: ["Economics", "Finance", "Business"]
  },
  "University of Wisconsin": {
    t: 43000, tIn: 11000, h: 15500, m: 6700, f: 2400,
    a: 49,
    r: "Top 40",
    state: "Wisconsin",
    majors: ["Economics", "Finance", "Business"]
  },
  "University of Illinois": {
    t: 44000, tIn: 16000, h: 16000, m: 6800, f: 2400,
    a: 45,
    r: "Top 40",
    state: "Illinois",
    majors: ["Economics", "Finance", "Business"]
  },
  "Penn State University": {
    t: 39000, tIn: 19500, h: 14500, m: 6500, f: 2300,
    a: 49,
    r: "Top 40",
    state: "Pennsylvania",
    majors: ["Economics", "Finance", "Business"]
  },
  "Ohio State University": {
    t: 36000, tIn: 12500, h: 13500, m: 6300, f: 2200,
    a: 52,
    r: "Top 40",
    state: "Ohio",
    majors: ["Economics", "Finance", "Business"]
  },
  "Purdue University": {
    t: 41000, tIn: 10000, h: 15000, m: 6600, f: 2300,
    a: 49,
    r: "Top 40",
    state: "Indiana",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Washington": {
    t: 43000, tIn: 12500, h: 15500, m: 6700, f: 2400,
    a: 48,
    r: "Top 40",
    state: "Washington",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Maryland": {
    t: 41000, tIn: 11000, h: 15000, m: 6600, f: 2400,
    a: 44,
    r: "Top 40",
    state: "Maryland",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Pittsburgh": {
    t: 38000, tIn: 20000, h: 14000, m: 6400, f: 2200,
    a: 49,
    r: "Top 40",
    state: "Pennsylvania",
    majors: ["Economics", "Business", "Finance"]
  },
  "Indiana University": {
    t: 38000, tIn: 11500, h: 14500, m: 6500, f: 2300,
    a: 68,
    r: "Top 40",
    state: "Indiana",
    majors: ["Finance", "Business", "Economics"]
  },
  "University of Minnesota": {
    t: 42000, tIn: 15500, h: 15500, m: 6700, f: 2400,
    a: 75,
    r: "Top 40",
    state: "Minnesota",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Georgia": {
    t: 33000, tIn: 12000, h: 13500, m: 6300, f: 2100,
    a: 42,
    r: "Top 40",
    state: "Georgia",
    majors: ["Economics", "Business", "Finance"]
  },
  "Clemson University": {
    t: 37000, tIn: 15500, h: 13500, m: 6300, f: 2200,
    a: 43,
    r: "Top 40",
    state: "South Carolina",
    majors: ["Economics", "Business", "Engineering"]
  },
  "Virginia Tech": {
    t: 36000, tIn: 14500, h: 13000, m: 6200, f: 2100,
    a: 57,
    r: "Top 40",
    state: "Virginia",
    majors: ["Engineering", "Business", "Economics"]
  },
  "Texas A&M University": {
    t: 40000, tIn: 12500, h: 14000, m: 6400, f: 2200,
    a: 58,
    r: "Top 40",
    state: "Texas",
    majors: ["Engineering", "Business", "Economics"]
  },
  "NC State University": {
    t: 34000, tIn: 9100, h: 13000, m: 6200, f: 2100,
    a: 47,
    r: "Top 40",
    state: "North Carolina",
    majors: ["Engineering", "Business", "Economics"]
  },
  "University of South Carolina": {
    t: 35000, tIn: 13000, h: 13500, m: 6300, f: 2100,
    a: 64,
    r: "Top 40",
    state: "South Carolina",
    majors: ["Business", "Economics", "Finance"]
  },

  // More State Universities
  "Florida State University": {
    t: 26000, tIn: 6500, h: 11500, m: 5900, f: 2000,
    a: 32,
    r: "Top 40",
    state: "Florida",
    majors: ["Finance", "Business", "Economics"]
  },
  "Rutgers University": {
    t: 39000, tIn: 16500, h: 14500, m: 6500, f: 2300,
    a: 50,
    r: "Top 40",
    state: "New Jersey",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Connecticut": {
    t: 40000, tIn: 17500, h: 14500, m: 6500, f: 2300,
    a: 55,
    r: "Top 40",
    state: "Connecticut",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Delaware": {
    t: 38000, tIn: 14500, h: 14000, m: 6400, f: 2200,
    a: 66,
    r: "Top 40",
    state: "Delaware",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Massachusetts Amherst": {
    t: 37000, tIn: 16500, h: 14000, m: 6400, f: 2200,
    a: 64,
    r: "Top 40",
    state: "Massachusetts",
    majors: ["Economics", "Business", "Finance"]
  },
  "Arizona State University": {
    t: 32000, tIn: 12000, h: 13000, m: 6200, f: 2100,
    a: 88,
    r: "Top 40",
    state: "Arizona",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of Arizona": {
    t: 34000, tIn: 13000, h: 13500, m: 6300, f: 2100,
    a: 87,
    r: "Top 40",
    state: "Arizona",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Colorado Boulder": {
    t: 39000, tIn: 14000, h: 15000, m: 6600, f: 2300,
    a: 79,
    r: "Top 40",
    state: "Colorado",
    majors: ["Economics", "Business", "Finance"]
  },
  "Colorado State University": {
    t: 33000, tIn: 12500, h: 13000, m: 6200, f: 2100,
    a: 91,
    r: "Top 40",
    state: "Colorado",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of Oregon": {
    t: 39000, tIn: 13500, h: 14500, m: 6500, f: 2300,
    a: 86,
    r: "Top 40",
    state: "Oregon",
    majors: ["Economics", "Business", "Finance"]
  },
  "Oregon State University": {
    t: 33000, tIn: 12500, h: 13000, m: 6200, f: 2100,
    a: 93,
    r: "Top 40",
    state: "Oregon",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Michigan State University": {
    t: 41000, tIn: 15000, h: 15000, m: 6600, f: 2300,
    a: 88,
    r: "Top 40",
    state: "Michigan",
    majors: ["Economics", "Business", "Finance"]
  },
  "Iowa State University": {
    t: 31000, tIn: 10000, h: 13000, m: 6200, f: 2100,
    a: 90,
    r: "Top 40",
    state: "Iowa",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Iowa": {
    t: 33000, tIn: 10500, h: 13000, m: 6200, f: 2100,
    a: 86,
    r: "Top 40",
    state: "Iowa",
    majors: ["Economics", "Business", "Finance"]
  },
  "University of Kansas": {
    t: 31000, tIn: 11500, h: 12500, m: 6100, f: 2000,
    a: 88,
    r: "Top 40",
    state: "Kansas",
    majors: ["Business", "Economics", "Finance"]
  },
  "Kansas State University": {
    t: 29000, tIn: 10500, h: 12000, m: 6000, f: 2000,
    a: 95,
    r: "Top 40",
    state: "Kansas",
    majors: ["Business", "Economics", "Engineering"]
  },
  "University of Nebraska": {
    t: 30000, tIn: 10000, h: 12500, m: 6100, f: 2000,
    a: 79,
    r: "Top 40",
    state: "Nebraska",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of Missouri": {
    t: 31000, tIn: 12000, h: 12500, m: 6100, f: 2000,
    a: 79,
    r: "Top 40",
    state: "Missouri",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of Oklahoma": {
    t: 29000, tIn: 10500, h: 12000, m: 6000, f: 2000,
    a: 83,
    r: "Top 40",
    state: "Oklahoma",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Oklahoma State University": {
    t: 27000, tIn: 9500, h: 11500, m: 5900, f: 2000,
    a: 70,
    r: "Top 40",
    state: "Oklahoma",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of Alabama": {
    t: 32000, tIn: 11500, h: 13000, m: 6200, f: 2100,
    a: 80,
    r: "Top 40",
    state: "Alabama",
    majors: ["Business", "Economics", "Finance"]
  },
  "Auburn University": {
    t: 32000, tIn: 12000, h: 13000, m: 6200, f: 2100,
    a: 71,
    r: "Top 40",
    state: "Alabama",
    majors: ["Engineering", "Business", "Economics"]
  },
  "University of Tennessee": {
    t: 33000, tIn: 13500, h: 13000, m: 6200, f: 2100,
    a: 68,
    r: "Top 40",
    state: "Tennessee",
    majors: ["Business", "Economics", "Engineering"]
  },
  "University of Kentucky": {
    t: 32000, tIn: 12500, h: 13000, m: 6200, f: 2100,
    a: 95,
    r: "Top 40",
    state: "Kentucky",
    majors: ["Business", "Economics", "Finance"]
  },
  "Louisiana State University": {
    t: 31000, tIn: 12000, h: 12500, m: 6100, f: 2000,
    a: 76,
    r: "Top 40",
    state: "Louisiana",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of Arkansas": {
    t: 28000, tIn: 10000, h: 12000, m: 6000, f: 2000,
    a: 78,
    r: "Top 40",
    state: "Arkansas",
    majors: ["Business", "Economics", "Finance"]
  },
  "Mississippi State University": {
    t: 26000, tIn: 9500, h: 11500, m: 5900, f: 2000,
    a: 75,
    r: "Top 40",
    state: "Mississippi",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of Mississippi": {
    t: 27000, tIn: 9500, h: 11500, m: 5900, f: 2000,
    a: 88,
    r: "Top 40",
    state: "Mississippi",
    majors: ["Business", "Economics", "Finance"]
  },
  "West Virginia University": {
    t: 27000, tIn: 9500, h: 11500, m: 5900, f: 2000,
    a: 84,
    r: "Top 40",
    state: "West Virginia",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of Utah": {
    t: 31000, tIn: 10000, h: 12500, m: 6100, f: 2000,
    a: 62,
    r: "Top 40",
    state: "Utah",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Utah State University": {
    t: 26000, tIn: 9000, h: 11000, m: 5800, f: 1900,
    a: 90,
    r: "Top 40",
    state: "Utah",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of Nevada Reno": {
    t: 28000, tIn: 9500, h: 12000, m: 6000, f: 2000,
    a: 86,
    r: "Top 40",
    state: "Nevada",
    majors: ["Business", "Economics", "Engineering"]
  },
  "University of New Mexico": {
    t: 27000, tIn: 8500, h: 11500, m: 5900, f: 2000,
    a: 96,
    r: "Top 40",
    state: "New Mexico",
    majors: ["Business", "Economics", "Engineering"]
  },
  "University of Idaho": {
    t: 28000, tIn: 9000, h: 11500, m: 5900, f: 2000,
    a: 74,
    r: "Top 40",
    state: "Idaho",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Washington State University": {
    t: 31000, tIn: 12500, h: 12500, m: 6100, f: 2000,
    a: 83,
    r: "Top 40",
    state: "Washington",
    majors: ["Business", "Economics", "Engineering"]
  },
  "Boise State University": {
    t: 26000, tIn: 8500, h: 11000, m: 5800, f: 1900,
    a: 84,
    r: "Top 40",
    state: "Idaho",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Montana State University": {
    t: 27000, tIn: 8000, h: 11000, m: 5800, f: 1900,
    a: 81,
    r: "Top 40",
    state: "Montana",
    majors: ["Engineering", "Business", "Economics"]
  },
  "University of Montana": {
    t: 28000, tIn: 8000, h: 11500, m: 5900, f: 2000,
    a: 95,
    r: "Top 40",
    state: "Montana",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of Wyoming": {
    t: 25000, tIn: 6500, h: 10500, m: 5700, f: 1900,
    a: 96,
    r: "Top 40",
    state: "Wyoming",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of North Dakota": {
    t: 26000, tIn: 9000, h: 11000, m: 5800, f: 1900,
    a: 88,
    r: "Top 40",
    state: "North Dakota",
    majors: ["Business", "Engineering", "Economics"]
  },
  "South Dakota State University": {
    t: 25000, tIn: 9000, h: 10500, m: 5700, f: 1900,
    a: 92,
    r: "Top 40",
    state: "South Dakota",
    majors: ["Engineering", "Business", "Economics"]
  },
  "University of South Dakota": {
    t: 24000, tIn: 9500, h: 10500, m: 5700, f: 1900,
    a: 99,
    r: "Top 40",
    state: "South Dakota",
    majors: ["Business", "Economics", "Finance"]
  },

  // Regional State Universities (SUNY = New York, CSU = California)
  "SUNY Buffalo": {
    t: 28000, tIn: 10500, h: 12500, m: 6100, f: 2000,
    a: 68,
    r: "Top 40",
    state: "New York",
    majors: ["Business", "Engineering", "Economics"]
  },
  "SUNY Stony Brook": {
    t: 28000, tIn: 10500, h: 12500, m: 6100, f: 2000,
    a: 49,
    r: "Top 40",
    state: "New York",
    majors: ["Economics", "Business", "Engineering"]
  },
  "SUNY Binghamton": {
    t: 28000, tIn: 10500, h: 12500, m: 6100, f: 2000,
    a: 42,
    r: "Top 40",
    state: "New York",
    majors: ["Economics", "Business", "Finance"]
  },
  "Cal State Long Beach": {
    t: 21000, tIn: 7000, h: 11000, m: 5800, f: 1800,
    a: 41,
    r: "Top 40",
    state: "California",
    majors: ["Business", "Economics", "Finance"]
  },
  "San Diego State": {
    t: 22000, tIn: 7500, h: 11500, m: 5900, f: 1900,
    a: 38,
    r: "Top 40",
    state: "California",
    majors: ["Business", "Economics", "Finance"]
  },
  "Cal State Fullerton": {
    t: 20000, tIn: 6900, h: 10500, m: 5700, f: 1800,
    a: 67,
    r: "Top 40",
    state: "California",
    majors: ["Business", "Economics", "Finance"]
  },
  "San Jose State": {
    t: 21000, tIn: 7800, h: 11000, m: 5800, f: 1800,
    a: 71,
    r: "Top 40",
    state: "California",
    majors: ["Engineering", "Business", "Economics"]
  },
  "Cal Poly San Luis Obispo": {
    t: 22000, tIn: 10000, h: 11500, m: 5900, f: 1900,
    a: 30,
    r: "Top 40",
    state: "California",
    majors: ["Engineering", "Business", "Economics"]
  },
  "University of Central Florida": {
    t: 27000, tIn: 6400, h: 11500, m: 5900, f: 2000,
    a: 41,
    r: "Top 40",
    state: "Florida",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Florida International": {
    t: 26000, tIn: 6600, h: 11500, m: 5900, f: 2000,
    a: 64,
    r: "Top 40",
    state: "Florida",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of South Florida": {
    t: 27000, tIn: 6400, h: 11500, m: 5900, f: 2000,
    a: 44,
    r: "Top 40",
    state: "Florida",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of North Texas": {
    t: 28000, tIn: 11000, h: 12000, m: 6000, f: 2000,
    a: 79,
    r: "Top 40",
    state: "Texas",
    majors: ["Business", "Economics", "Finance"]
  },
  "Texas Tech University": {
    t: 29000, tIn: 11500, h: 12000, m: 6000, f: 2000,
    a: 69,
    r: "Top 40",
    state: "Texas",
    majors: ["Engineering", "Business", "Economics"]
  },
  "University of Houston": {
    t: 30000, tIn: 11500, h: 12500, m: 6100, f: 2000,
    a: 66,
    r: "Top 40",
    state: "Texas",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Georgia State University": {
    t: 30000, tIn: 10500, h: 12500, m: 6100, f: 2000,
    a: 67,
    r: "Top 40",
    state: "Georgia",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of Louisville": {
    t: 29000, tIn: 12500, h: 12000, m: 6000, f: 2000,
    a: 82,
    r: "Top 40",
    state: "Kentucky",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of Cincinnati": {
    t: 30000, tIn: 12500, h: 12500, m: 6100, f: 2000,
    a: 86,
    r: "Top 40",
    state: "Ohio",
    majors: ["Engineering", "Business", "Economics"]
  },
  "University of Akron": {
    t: 27000, tIn: 12000, h: 11500, m: 5900, f: 2000,
    a: 96,
    r: "Top 40",
    state: "Ohio",
    majors: ["Engineering", "Business", "Economics"]
  },
  "Wayne State University": {
    t: 28000, tIn: 14000, h: 12000, m: 6000, f: 2000,
    a: 75,
    r: "Top 40",
    state: "Michigan",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Temple University": {
    t: 33000, tIn: 20000, h: 13000, m: 6200, f: 2100,
    a: 80,
    r: "Top 40",
    state: "Pennsylvania",
    majors: ["Business", "Economics", "Finance"]
  },
  "Drexel University": {
    t: 57000, h: 17500, m: 7100, f: 2700,
    a: 80,
    r: "Top 40",
    majors: ["Engineering", "Business", "Economics"]
  },

  // Additional 100 Colleges
  "Villanova University": {
    t: 59000, h: 17500, m: 7100, f: 2700,
    a: 23,
    r: "Top 40",
    majors: ["Business", "Economics", "Finance"]
  },
  "Pepperdine University": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 32,
    r: "Top 40",
    majors: ["Business", "Economics", "Finance"]
  },
  "Santa Clara University": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 49,
    r: "Top 40",
    majors: ["Business", "Engineering", "Economics"]
  },
  "Loyola Marymount": {
    t: 54000, h: 17000, m: 6900, f: 2600,
    a: 47,
    r: "Top 40",
    majors: ["Business", "Economics", "Finance"]
  },
  "University of San Diego": {
    t: 55000, h: 17500, m: 7100, f: 2700,
    a: 53,
    r: "Top 40",
    majors: ["Business", "Economics", "Finance"]
  },
  "Chapman University": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 54,
    r: "Top 40",
    majors: ["Business", "Film", "Economics"]
  },
  "Gonzaga University": {
    t: 48000, h: 15500, m: 6700, f: 2400,
    a: 70,
    r: "Top 40",
    majors: ["Business", "Engineering", "Economics"]
  },
  "University of San Francisco": {
    t: 52000, h: 17000, m: 6900, f: 2600,
    a: 71,
    r: "Top 40",
    majors: ["Business", "Economics", "Nursing"]
  },
  "Seattle University": {
    t: 49000, h: 16000, m: 6800, f: 2500,
    a: 82,
    r: "Top 40",
    majors: ["Business", "Nursing", "Engineering"]
  },
  "University of Portland": {
    t: 50000, h: 16000, m: 6800, f: 2500,
    a: 78,
    r: "Top 40",
    majors: ["Engineering", "Business", "Nursing"]
  },
  "Marquette University": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 82,
    r: "Top 40",
    majors: ["Business", "Engineering", "Health Sciences"]
  },
  "DePaul University": {
    t: 43000, h: 15000, m: 6600, f: 2300,
    a: 68,
    r: "Top 40",
    majors: ["Business", "Computer Science", "Economics"]
  },
  "Loyola University Chicago": {
    t: 47000, h: 15500, m: 6700, f: 2400,
    a: 79,
    r: "Top 40",
    majors: ["Business", "Nursing", "Psychology"]
  },
  "Xavier University": {
    t: 43000, h: 14500, m: 6500, f: 2300,
    a: 84,
    r: "Top 40",
    majors: ["Business", "Nursing", "Education"]
  },
  "Creighton University": {
    t: 44000, h: 14500, m: 6500, f: 2300,
    a: 76,
    r: "Top 40",
    majors: ["Business", "Health Sciences", "Nursing"]
  },
  "Butler University": {
    t: 45000, h: 15000, m: 6600, f: 2400,
    a: 75,
    r: "Top 40",
    majors: ["Business", "Pharmacy", "Education"]
  },
  "Providence College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 51,
    r: "Top 40",
    majors: ["Business", "Economics", "Education"]
  },
  "Fairfield University": {
    t: 52000, h: 16500, m: 6800, f: 2500,
    a: 58,
    r: "Top 40",
    majors: ["Business", "Nursing", "Engineering"]
  },
  "University of Dayton": {
    t: 45000, h: 15000, m: 6600, f: 2400,
    a: 72,
    r: "Top 40",
    majors: ["Engineering", "Business", "Education"]
  },
  "St. Louis University": {
    t: 48000, h: 15500, m: 6700, f: 2400,
    a: 85,
    r: "Top 40",
    majors: ["Business", "Health Sciences", "Engineering"]
  },
  "University of Denver": {
    t: 54000, h: 16500, m: 6800, f: 2500,
    a: 59,
    r: "Top 40",
    majors: ["Business", "Engineering", "International Studies"]
  },
  "SMU": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 52,
    r: "Top 40",
    majors: ["Business", "Engineering", "Arts"]
  },
  "TCU": {
    t: 52000, h: 16500, m: 6800, f: 2500,
    a: 47,
    r: "Top 40",
    majors: ["Business", "Nursing", "Communication"]
  },
  "Baylor University": {
    t: 50000, h: 16000, m: 6800, f: 2500,
    a: 46,
    r: "Top 40",
    majors: ["Business", "Engineering", "Pre-Med"]
  },
  "American University": {
    t: 52000, h: 17000, m: 6900, f: 2600,
    a: 64,
    r: "Top 40",
    majors: ["International Relations", "Political Science", "Business"]
  },
  "George Washington University": {
    t: 59000, h: 18500, m: 7300, f: 2900,
    a: 43,
    r: "Top 40",
    majors: ["International Affairs", "Business", "Political Science"]
  },
  "Hofstra University": {
    t: 49000, h: 16000, m: 6800, f: 2500,
    a: 69,
    r: "Top 40",
    majors: ["Business", "Communications", "Education"]
  },
  "Pace University": {
    t: 47000, h: 17000, m: 6900, f: 2600,
    a: 76,
    r: "Top 40",
    majors: ["Business", "Computer Science", "Nursing"]
  },
  "Ithaca College": {
    t: 48000, h: 16000, m: 6800, f: 2500,
    a: 75,
    r: "Top 40",
    majors: ["Communications", "Business", "Music"]
  },
  "Quinnipiac University": {
    t: 50000, h: 16000, m: 6800, f: 2500,
    a: 73,
    r: "Top 40",
    majors: ["Health Sciences", "Business", "Communications"]
  },
  "Elon University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 78,
    r: "Top 40",
    majors: ["Business", "Communications", "Education"]
  },
  "High Point University": {
    t: 39000, h: 14500, m: 6500, f: 2300,
    a: 77,
    r: "Top 40",
    majors: ["Business", "Communications", "Education"]
  },
  "Belmont University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 82,
    r: "Top 40",
    majors: ["Music Business", "Business", "Nursing"]
  },
  "Samford University": {
    t: 35000, h: 13500, m: 6300, f: 2100,
    a: 83,
    r: "Top 40",
    majors: ["Business", "Nursing", "Pharmacy"]
  },
  "Furman University": {
    t: 53000, h: 16500, m: 6800, f: 2500,
    a: 64,
    r: "Top 40",
    majors: ["Business", "Political Science", "Health Sciences"]
  },
  "Rhodes College": {
    t: 50000, h: 16000, m: 6800, f: 2500,
    a: 54,
    r: "Top 40",
    majors: ["Business", "International Studies", "Biology"]
  },
  "College of Charleston": {
    t: 29000, tIn: 13000, h: 12500, m: 6100, f: 2000,
    a: 76,
    r: "Top 40",
    state: "South Carolina",
    majors: ["Business", "Marine Biology", "Education"]
  },
  "James Madison University": {
    t: 30000, tIn: 13500, h: 12500, m: 6100, f: 2000,
    a: 71,
    r: "Top 40",
    state: "Virginia",
    majors: ["Business", "Engineering", "Education"]
  },
  "College of William & Mary": {
    t: 48000, tIn: 24000, h: 16000, m: 6800, f: 2500,
    a: 37,
    r: "Top 40",
    state: "Virginia",
    majors: ["Business", "Government", "Economics"]
  },
  "Miami University Ohio": {
    t: 37000, tIn: 16500, h: 14000, m: 6400, f: 2200,
    a: 88,
    r: "Top 40",
    state: "Ohio",
    majors: ["Business", "Engineering", "Education"]
  },
  "University of Vermont": {
    t: 45000, tIn: 19000, h: 15500, m: 6700, f: 2400,
    a: 60,
    r: "Top 40",
    state: "Vermont",
    majors: ["Business", "Environmental Studies", "Engineering"]
  },
  "University of New Hampshire": {
    t: 35000, tIn: 19000, h: 13500, m: 6300, f: 2100,
    a: 87,
    r: "Top 40",
    state: "New Hampshire",
    majors: ["Business", "Engineering", "Marine Science"]
  },
  "University of Rhode Island": {
    t: 33000, tIn: 15000, h: 13000, m: 6200, f: 2100,
    a: 76,
    r: "Top 40",
    state: "Rhode Island",
    majors: ["Business", "Pharmacy", "Engineering"]
  },
  "University of Maine": {
    t: 32000, tIn: 12000, h: 12500, m: 6100, f: 2000,
    a: 94,
    r: "Top 40",
    state: "Maine",
    majors: ["Engineering", "Business", "Marine Science"]
  },
  "Clemson University": {
    t: 37000, h: 13500, m: 6300, f: 2200,
    a: 43,
    r: "Top 40",
    majors: ["Engineering", "Business", "Agriculture"]
  },
  "University of Alabama Birmingham": {
    t: 30000, tIn: 10000, h: 12500, m: 6100, f: 2000,
    a: 87,
    r: "Top 40",
    state: "Alabama",
    majors: ["Health Sciences", "Business", "Engineering"]
  },
  "University of Memphis": {
    t: 28000, tIn: 10000, h: 12000, m: 6000, f: 2000,
    a: 95,
    r: "Top 40",
    state: "Tennessee",
    majors: ["Business", "Engineering", "Education"]
  },
  "East Carolina University": {
    t: 27000, tIn: 7400, h: 11500, m: 5900, f: 2000,
    a: 93,
    r: "Top 40",
    state: "North Carolina",
    majors: ["Business", "Health Sciences", "Education"]
  },
  "Old Dominion University": {
    t: 31000, tIn: 12000, h: 12500, m: 6100, f: 2000,
    a: 96,
    r: "Top 40",
    state: "Virginia",
    majors: ["Engineering", "Business", "Education"]
  },
  "George Mason University": {
    t: 35000, tIn: 13500, h: 13500, m: 6300, f: 2100,
    a: 90,
    r: "Top 40",
    state: "Virginia",
    majors: ["Business", "Engineering", "Public Policy"]
  },
  "VCU": {
    t: 33000, tIn: 15000, h: 13000, m: 6200, f: 2100,
    a: 91,
    r: "Top 40",
    state: "Virginia",
    majors: ["Arts", "Business", "Health Sciences"]
  },
  "Towson University": {
    t: 29000, tIn: 10500, h: 12000, m: 6000, f: 2000,
    a: 79,
    r: "Top 40",
    state: "Maryland",
    majors: ["Business", "Education", "Health Sciences"]
  },
  "University of Maryland Baltimore County": {
    t: 31000, tIn: 13000, h: 12500, m: 6100, f: 2000,
    a: 61,
    r: "Top 40",
    state: "Maryland",
    majors: ["Engineering", "Computer Science", "Biology"]
  },
  "Rowan University": {
    t: 30000, tIn: 14500, h: 12500, m: 6100, f: 2000,
    a: 77,
    r: "Top 40",
    state: "New Jersey",
    majors: ["Engineering", "Business", "Education"]
  },
  "Montclair State": {
    t: 29000, tIn: 13500, h: 12000, m: 6000, f: 2000,
    a: 75,
    r: "Top 40",
    state: "New Jersey",
    majors: ["Business", "Education", "Arts"]
  },
  "Seton Hall University": {
    t: 45000, h: 15000, m: 6600, f: 2400,
    a: 75,
    r: "Top 40",
    majors: ["Business", "Nursing", "Diplomacy"]
  },
  "Stevens Institute of Technology": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 46,
    r: "Top 40",
    majors: ["Engineering", "Computer Science", "Business"]
  },
  "Worcester Polytechnic": {
    t: 54000, h: 17000, m: 6900, f: 2600,
    a: 57,
    r: "Top 40",
    majors: ["Engineering", "Computer Science", "Business"]
  },
  "Rochester Institute of Technology": {
    t: 51000, h: 16500, m: 6800, f: 2500,
    a: 67,
    r: "Top 40",
    majors: ["Engineering", "Computer Science", "Business"]
  },
  "Clarkson University": {
    t: 52000, h: 16000, m: 6800, f: 2500,
    a: 78,
    r: "Top 40",
    majors: ["Engineering", "Business", "Health Sciences"]
  },
  "Union College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 46,
    r: "Top 40",
    majors: ["Engineering", "Economics", "Political Science"]
  },
  "Trinity College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 36,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Neuroscience"]
  },
  "Connecticut College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 40,
    r: "Top 40",
    majors: ["Economics", "Government", "Psychology"]
  },
  "Lafayette College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 31,
    r: "Top 40",
    majors: ["Engineering", "Economics", "Government"]
  },
  "Bucknell University": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 35,
    r: "Top 40",
    majors: ["Engineering", "Business", "Economics"]
  },
  "Colgate University": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 17,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Biology"]
  },
  "Hamilton College": {
    t: 59000, h: 17500, m: 7100, f: 2700,
    a: 16,
    r: "Top 40",
    majors: ["Economics", "Government", "Mathematics"]
  },
  "Colby College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 10,
    r: "Top 40",
    majors: ["Economics", "Government", "Environmental Science"]
  },
  "Bates College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 14,
    r: "Top 40",
    majors: ["Economics", "Politics", "Psychology"]
  },
  "Bowdoin College": {
    t: 59000, h: 18000, m: 7200, f: 2800,
    a: 9,
    r: "Top 40",
    majors: ["Economics", "Government", "Neuroscience"]
  },
  "Middlebury College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 13,
    r: "Top 40",
    majors: ["Economics", "International Studies", "Environmental Studies"]
  },
  "Williams College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 13,
    r: "Top 10",
    majors: ["Economics", "Political Science", "Mathematics"]
  },
  "Amherst College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 9,
    r: "Top 10",
    majors: ["Economics", "Political Science", "English"]
  },
  "Swarthmore College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 9,
    r: "Top 10",
    majors: ["Economics", "Engineering", "Political Science"]
  },
  "Haverford College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 18,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Biology"]
  },
  "Bryn Mawr College": {
    t: 54000, h: 17000, m: 6900, f: 2600,
    a: 38,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Biology"]
  },
  "Barnard College": {
    t: 59000, h: 18500, m: 7300, f: 2900,
    a: 11,
    r: "Top 40",
    majors: ["Economics", "Political Science", "English"]
  },
  "Mount Holyoke College": {
    t: 52000, h: 16500, m: 6800, f: 2500,
    a: 52,
    r: "Top 40",
    majors: ["Economics", "International Relations", "Biology"]
  },
  "Smith College": {
    t: 54000, h: 17000, m: 6900, f: 2600,
    a: 32,
    r: "Top 40",
    majors: ["Economics", "Government", "Engineering"]
  },
  "Wellesley College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 20,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Neuroscience"]
  },
  "Vassar College": {
    t: 59000, h: 18000, m: 7200, f: 2800,
    a: 24,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Drama"]
  },
  "Wesleyan University": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 21,
    r: "Top 40",
    majors: ["Economics", "Government", "Film"]
  },
  "Oberlin College": {
    t: 57000, h: 17000, m: 6900, f: 2600,
    a: 35,
    r: "Top 40",
    majors: ["Economics", "Politics", "Music"]
  },
  "Kenyon College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 34,
    r: "Top 40",
    majors: ["Economics", "Political Science", "English"]
  },
  "Denison University": {
    t: 54000, h: 16500, m: 6800, f: 2500,
    a: 32,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Biology"]
  },
  "College of Wooster": {
    t: 51000, h: 16000, m: 6800, f: 2500,
    a: 56,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Chemistry"]
  },
  "Dickinson College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 48,
    r: "Top 40",
    majors: ["International Business", "Political Science", "Environmental Science"]
  },
  "Franklin & Marshall": {
    t: 59000, h: 17500, m: 7100, f: 2700,
    a: 36,
    r: "Top 40",
    majors: ["Business", "Government", "Biology"]
  },
  "Gettysburg College": {
    t: 57000, h: 17000, m: 6900, f: 2600,
    a: 48,
    r: "Top 40",
    majors: ["Business", "Political Science", "Biology"]
  },
  "Muhlenberg College": {
    t: 53000, h: 16500, m: 6800, f: 2500,
    a: 66,
    r: "Top 40",
    majors: ["Business", "Biology", "Theatre"]
  },
  "Skidmore College": {
    t: 57000, h: 17500, m: 7100, f: 2700,
    a: 31,
    r: "Top 40",
    majors: ["Business", "Studio Art", "Psychology"]
  },
  "Bard College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 60,
    r: "Top 40",
    majors: ["Economics", "Political Studies", "Film"]
  },
  "Sarah Lawrence College": {
    t: 57000, h: 18000, m: 7200, f: 2800,
    a: 56,
    r: "Top 40",
    majors: ["Writing", "Theatre", "Psychology"]
  },
  "Macalester College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 31,
    r: "Top 40",
    majors: ["Economics", "International Studies", "Political Science"]
  },
  "Carleton College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 20,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Computer Science"]
  },
  "Grinnell College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 11,
    r: "Top 40",
    majors: ["Economics", "Political Science", "Biology"]
  },
  "Pomona College": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 9,
    r: "Top 10",
    majors: ["Economics", "Public Policy", "Neuroscience"]
  },
  "Claremont McKenna": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 13,
    r: "Top 40",
    majors: ["Economics", "Government", "International Relations"]
  },
  "Harvey Mudd College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 18,
    r: "Top 40",
    majors: ["Engineering", "Computer Science", "Mathematics"]
  },
  "Pitzer College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 18,
    r: "Top 40",
    majors: ["Environmental Analysis", "Psychology", "Sociology"]
  },
  "Scripps College": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 30,
    r: "Top 40",
    majors: ["Economics", "Psychology", "Politics"]
  },
  
  // Additional Colleges - Batch 2
  "University of Hawaii Manoa": {
    t: 32000, h: 13000, m: 6200, f: 2100,
    a: 58,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Arts & Media"]
  },
  "University of Alaska Fairbanks": {
    t: 26000, h: 11000, m: 5800, f: 1900,
    a: 75,
    r: "Top 40",
    majors: ["STEM", "Agriculture & Environment", "Business & Economics"]
  },
  "Northern Arizona University": {
    t: 28000, h: 12000, m: 6000, f: 2000,
    a: 87,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Health Sciences"]
  },
  "New Mexico State University": {
    t: 26000, h: 11500, m: 5900, f: 2000,
    a: 68,
    r: "Top 40",
    majors: ["Agriculture & Environment", "STEM", "Business & Economics"]
  },
  "University of Nevada Las Vegas": {
    t: 29000, h: 12500, m: 6100, f: 2000,
    a: 84,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "Health Sciences"]
  },
  "Weber State University": {
    t: 22000, h: 10500, m: 5700, f: 1800,
    a: 100,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Education"]
  },
  "Brigham Young University": {
    t: 12000, h: 9500, m: 5200, f: 1600,
    a: 53,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Humanities"]
  },
  "Grand Canyon University": {
    t: 35000, h: 13500, m: 6300, f: 2100,
    a: 100,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Health Sciences"]
  },
  "Liberty University": {
    t: 36000, h: 13500, m: 6300, f: 2100,
    a: 50,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Health Sciences"]
  },
  "Regent University": {
    t: 32000, h: 12500, m: 6100, f: 2000,
    a: 94,
    r: "Top 40",
    majors: ["Business & Economics", "Public Policy & Law", "Education"]
  },
  "University of Tulsa": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 71,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Arts & Media"]
  },
  "Oral Roberts University": {
    t: 34000, h: 13000, m: 6200, f: 2100,
    a: 72,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Health Sciences"]
  },
  "Wichita State University": {
    t: 24000, h: 11000, m: 5800, f: 1900,
    a: 96,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  },
  "Washburn University": {
    t: 22000, h: 10500, m: 5700, f: 1800,
    a: 99,
    r: "Top 40",
    majors: ["Business & Economics", "Public Policy & Law", "Health Sciences"]
  },
  "University of Nebraska Omaha": {
    t: 25000, h: 11000, m: 5800, f: 1900,
    a: 86,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Education"]
  },
  "Truman State University": {
    t: 24000, h: 10500, m: 5700, f: 1800,
    a: 61,
    r: "Top 40",
    majors: ["Business & Economics", "Humanities", "Health Sciences"]
  },
  "Missouri State University": {
    t: 24000, h: 11000, m: 5800, f: 1900,
    a: 83,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Health Sciences"]
  },
  "Southeast Missouri State": {
    t: 23000, h: 10500, m: 5700, f: 1800,
    a: 87,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "STEM"]
  },
  "Southern Illinois University": {
    t: 27000, h: 11500, m: 5900, f: 2000,
    a: 83,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Arts & Media"]
  },
  "Northern Illinois University": {
    t: 26000, h: 11500, m: 5900, f: 2000,
    a: 56,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Education"]
  },
  "Western Illinois University": {
    t: 24000, h: 10500, m: 5700, f: 1800,
    a: 56,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Social Sciences"]
  },
  "Ball State University": {
    t: 28000, h: 12000, m: 6000, f: 2000,
    a: 65,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "Education"]
  },
  "Valparaiso University": {
    t: 44000, h: 15000, m: 6600, f: 2400,
    a: 91,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Humanities"]
  },
  "University of Evansville": {
    t: 42000, h: 14500, m: 6500, f: 2300,
    a: 66,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Health Sciences"]
  },
  "Bradley University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 68,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  },
  "Illinois State University": {
    t: 28000, h: 12000, m: 6000, f: 2000,
    a: 85,
    r: "Top 40",
    majors: ["Education", "Business & Economics", "STEM"]
  },
  "Eastern Illinois University": {
    t: 24000, h: 10500, m: 5700, f: 1800,
    a: 56,
    r: "Top 40",
    majors: ["Education", "Business & Economics", "Arts & Media"]
  },
  "Western Michigan University": {
    t: 29000, h: 12000, m: 6000, f: 2000,
    a: 78,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Aviation"]
  },
  "Central Michigan University": {
    t: 27000, h: 11500, m: 5900, f: 2000,
    a: 70,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Health Sciences"]
  },
  "Eastern Michigan University": {
    t: 26000, h: 11500, m: 5900, f: 2000,
    a: 79,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "STEM"]
  },
  "Grand Valley State University": {
    t: 27000, h: 11500, m: 5900, f: 2000,
    a: 81,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "STEM"]
  },
  "University of Toledo": {
    t: 27000, h: 11500, m: 5900, f: 2000,
    a: 95,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  },
  "Bowling Green State University": {
    t: 28000, h: 12000, m: 6000, f: 2000,
    a: 79,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "Education"]
  },
  "Kent State University": {
    t: 28000, h: 12000, m: 6000, f: 2000,
    a: 85,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "STEM"]
  },
  "Youngstown State University": {
    t: 23000, h: 10500, m: 5700, f: 1800,
    a: 68,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  },
  "Cleveland State University": {
    t: 26000, h: 11500, m: 5900, f: 2000,
    a: 87,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Public Policy & Law"]
  },
  "Wright State University": {
    t: 25000, h: 11000, m: 5800, f: 1900,
    a: 95,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  },
  "Marshall University": {
    t: 24000, h: 10500, m: 5700, f: 1800,
    a: 77,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "STEM"]
  },
  "Duquesne University": {
    t: 44000, h: 14500, m: 6500, f: 2300,
    a: 74,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Education"]
  },
  "Robert Morris University": {
    t: 34000, h: 13000, m: 6200, f: 2100,
    a: 85,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Health Sciences"]
  },
  "Point Park University": {
    t: 36000, h: 13500, m: 6300, f: 2100,
    a: 67,
    r: "Top 40",
    majors: ["Arts & Media", "Business & Economics", "STEM"]
  },
  "La Salle University": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 81,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Education"]
  },
  "Saint Joseph's University": {
    t: 48000, h: 16000, m: 6800, f: 2500,
    a: 82,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Arts & Media"]
  },
  "Widener University": {
    t: 50000, h: 16000, m: 6800, f: 2500,
    a: 72,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  },
  "Rider University": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 72,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "Education"]
  },
  "Monmouth University": {
    t: 42000, h: 14500, m: 6500, f: 2300,
    a: 81,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "Health Sciences"]
  },
  "Fairleigh Dickinson University": {
    t: 45000, h: 15000, m: 6600, f: 2400,
    a: 85,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "STEM"]
  },
  "Drew University": {
    t: 52000, h: 16500, m: 6800, f: 2500,
    a: 71,
    r: "Top 40",
    majors: ["Humanities", "Social Sciences", "Business & Economics"]
  },
  "Adelphi University": {
    t: 44000, h: 15000, m: 6600, f: 2400,
    a: 72,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "Social Sciences"]
  },
  "Long Island University": {
    t: 42000, h: 14500, m: 6500, f: 2300,
    a: 83,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "Arts & Media"]
  },
  "CUNY Baruch College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 27,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "Arts & Media", "Social Sciences"]
  },
  "CUNY Hunter College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 37,
    r: "Top 40",
    state: "New York",
    majors: ["Health Sciences", "Social Sciences", "STEM"]
  },
  "CUNY City College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 47,
    r: "Top 40",
    state: "New York",
    majors: ["STEM", "Business & Economics", "Social Sciences"]
  },
  "CUNY Brooklyn College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 54,
    r: "Top 40",
    state: "New York",
    majors: ["Arts & Media", "Social Sciences", "Business & Economics"]
  },
  "CUNY Queens College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 60,
    r: "Top 40",
    state: "New York",
    majors: ["Social Sciences", "STEM", "Arts & Media"]
  },
  "Marist College": {
    t: 44000, h: 15000, m: 6600, f: 2400,
    a: 42,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "STEM"]
  },
  "Manhattan College": {
    t: 48000, h: 16000, m: 6800, f: 2500,
    a: 73,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Education"]
  },
  "St. John's University": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 64,
    r: "Top 40",
    majors: ["Business & Economics", "Public Policy & Law", "Health Sciences"]
  },
  "Niagara University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 84,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Health Sciences"]
  },
  "Canisius College": {
    t: 40000, h: 14500, m: 6500, f: 2300,
    a: 86,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "STEM"]
  },
  "University at Albany SUNY": {
    t: 26000, tIn: 10500, h: 11500, m: 5900, f: 2000,
    a: 55,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "Social Sciences", "STEM"]
  },
  "SUNY Oswego": {
    t: 24000, tIn: 8700, h: 11000, m: 5800, f: 1900,
    a: 55,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "Arts & Media", "Education"]
  },
  "SUNY Plattsburgh": {
    t: 24000, tIn: 8700, h: 11000, m: 5800, f: 1900,
    a: 60,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "Education", "Health Sciences"]
  },
  "SUNY Geneseo": {
    t: 24000, tIn: 8700, h: 11000, m: 5800, f: 1900,
    a: 67,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "Humanities", "STEM"]
  },
  "SUNY New Paltz": {
    t: 24000, tIn: 8700, h: 11000, m: 5800, f: 1900,
    a: 45,
    r: "Top 40",
    state: "New York",
    majors: ["Arts & Media", "Business & Economics", "Education"]
  },
  "SUNY Purchase": {
    t: 24000, tIn: 8700, h: 11000, m: 5800, f: 1900,
    a: 44,
    r: "Top 40",
    state: "New York",
    majors: ["Arts & Media", "Humanities", "Social Sciences"]
  },
  "Sacred Heart University": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 68,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "STEM"]
  },
  "University of Hartford": {
    t: 44000, h: 14500, m: 6500, f: 2300,
    a: 66,
    r: "Top 40",
    majors: ["Arts & Media", "Business & Economics", "STEM"]
  },
  "Central Connecticut State": {
    t: 26000, h: 11500, m: 5900, f: 2000,
    a: 70,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "STEM"]
  },
  "Southern Connecticut State": {
    t: 26000, h: 11500, m: 5900, f: 2000,
    a: 77,
    r: "Top 40",
    majors: ["Health Sciences", "Education", "Business & Economics"]
  },
  "Western Connecticut State": {
    t: 24000, h: 11000, m: 5800, f: 1900,
    a: 85,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "Health Sciences"]
  },
  "Eastern Connecticut State": {
    t: 24000, h: 11000, m: 5800, f: 1900,
    a: 68,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Social Sciences"]
  },
  "Plymouth State University": {
    t: 28000, h: 12000, m: 6000, f: 2000,
    a: 85,
    r: "Top 40",
    majors: ["Business & Economics", "Education", "Agriculture & Environment"]
  },
  "Keene State College": {
    t: 26000, h: 11500, m: 5900, f: 2000,
    a: 91,
    r: "Top 40",
    majors: ["Education", "STEM", "Arts & Media"]
  },
  "Southern New Hampshire University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 92,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Health Sciences"]
  },
  "Assumption University": {
    t: 44000, h: 14500, m: 6500, f: 2300,
    a: 77,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Social Sciences"]
  },
  "Merrimack College": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 82,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Health Sciences"]
  },
  "Stonehill College": {
    t: 48000, h: 16000, m: 6800, f: 2500,
    a: 66,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Social Sciences"]
  },
  "Bentley University": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 38,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Social Sciences"]
  },
  "Babson College": {
    t: 56000, h: 17500, m: 7100, f: 2700,
    a: 24,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Social Sciences"]
  },
  "Suffolk University": {
    t: 44000, h: 17000, m: 6900, f: 2600,
    a: 90,
    r: "Top 40",
    majors: ["Business & Economics", "Public Policy & Law", "Arts & Media"]
  },
  "Emerson College": {
    t: 52000, h: 18000, m: 7200, f: 2800,
    a: 39,
    r: "Top 40",
    majors: ["Arts & Media", "Business & Economics", "Humanities"]
  },
  "Simmons University": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 87,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "Social Sciences"]
  },
  "Roger Williams University": {
    t: 42000, h: 14500, m: 6500, f: 2300,
    a: 88,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Public Policy & Law"]
  },
  "Bryant University": {
    t: 48000, h: 16000, m: 6800, f: 2500,
    a: 74,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Health Sciences"]
  },
  "Salve Regina University": {
    t: 44000, h: 14500, m: 6500, f: 2300,
    a: 77,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Education"]
  },
  "Johnson & Wales University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 80,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "Health Sciences"]
  },
  "Champlain College": {
    t: 44000, h: 14500, m: 6500, f: 2300,
    a: 72,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Arts & Media"]
  },
  "Saint Michael's College": {
    t: 50000, h: 16000, m: 6800, f: 2500,
    a: 84,
    r: "Top 40",
    majors: ["Business & Economics", "Humanities", "Social Sciences"]
  },
  "Norwich University": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 79,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Public Policy & Law"]
  },
  "St. Lawrence University": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 44,
    r: "Top 40",
    majors: ["Social Sciences", "Humanities", "Agriculture & Environment"]
  },
  "Alfred University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 60,
    r: "Top 40",
    majors: ["Arts & Media", "STEM", "Business & Economics"]
  },
  "Hobart and William Smith": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 58,
    r: "Top 40",
    majors: ["Social Sciences", "Humanities", "STEM"]
  },
  "Skidmore College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 33,
    r: "Top 40",
    majors: ["Arts & Media", "Business & Economics", "Social Sciences"]
  },
  "University of Scranton": {
    t: 48000, h: 16000, m: 6800, f: 2500,
    a: 77,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "STEM"]
  },
  "Elizabethtown College": {
    t: 50000, h: 16000, m: 6800, f: 2500,
    a: 87,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "Education"]
  },
  "Gettysburg College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 44,
    r: "Top 40",
    majors: ["Business & Economics", "Social Sciences", "Humanities"]
  },
  "Dickinson College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 43,
    r: "Top 40",
    majors: ["Social Sciences", "Humanities", "STEM"]
  },
  "Franklin & Marshall College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 31,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Social Sciences"]
  },
  "Muhlenberg College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 58,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Arts & Media"]
  },
  "Susquehanna University": {
    t: 52000, h: 16500, m: 6800, f: 2500,
    a: 72,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "STEM"]
  },
  "Ursinus College": {
    t: 56000, h: 17000, m: 6900, f: 2600,
    a: 77,
    r: "Top 40",
    majors: ["STEM", "Business & Economics", "Social Sciences"]
  },
  
  // Additional New York Schools - SUNYs (All New York state public schools)
  "SUNY Albany": {
    t: 27000, tIn: 10500, h: 14000, m: 6000, f: 2000,
    a: 55,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "Social Sciences", "STEM"]
  },
  "SUNY Cortland": {
    t: 24000, tIn: 8700, h: 13000, m: 5800, f: 1900,
    a: 50,
    r: "Top 40",
    state: "New York",
    majors: ["Education", "Health Sciences", "Social Sciences"]
  },
  "SUNY Oneonta": {
    t: 24000, tIn: 8700, h: 13000, m: 5800, f: 1900,
    a: 55,
    r: "Top 40",
    state: "New York",
    majors: ["Education", "Business & Economics", "STEM"]
  },
  "SUNY Fredonia": {
    t: 24000, tIn: 8700, h: 13000, m: 5800, f: 1900,
    a: 62,
    r: "Top 40",
    state: "New York",
    majors: ["Arts & Media", "Education", "Business & Economics"]
  },
  "SUNY Brockport": {
    t: 24000, tIn: 8700, h: 13000, m: 5800, f: 1900,
    a: 58,
    r: "Top 40",
    state: "New York",
    majors: ["Education", "Health Sciences", "Business & Economics"]
  },
  "SUNY Potsdam": {
    t: 24000, tIn: 8700, h: 13000, m: 5800, f: 1900,
    a: 70,
    r: "Top 40",
    state: "New York",
    majors: ["Arts & Media", "Education", "STEM"]
  },
  "SUNY Old Westbury": {
    t: 24000, tIn: 8700, h: 13000, m: 5800, f: 1900,
    a: 67,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "Education", "Social Sciences"]
  },
  "SUNY Polytechnic Institute": {
    t: 26000, tIn: 9500, h: 14000, m: 6000, f: 2000,
    a: 65,
    r: "Top 40",
    state: "New York",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  },
  "SUNY Maritime College": {
    t: 26000, tIn: 9500, h: 14000, m: 6000, f: 2000,
    a: 55,
    r: "Top 40",
    state: "New York",
    majors: ["STEM", "Business & Economics", "Other"]
  },
  "SUNY ESF (Environmental Science & Forestry)": {
    t: 26000, tIn: 9500, h: 14000, m: 6000, f: 2000,
    a: 52,
    r: "Top 40",
    state: "New York",
    majors: ["Agriculture & Environment", "STEM", "Other"]
  },
  "SUNY Morrisville": {
    t: 22000, tIn: 8500, h: 12000, m: 5500, f: 1800,
    a: 85,
    r: "Top 40",
    state: "New York",
    majors: ["Agriculture & Environment", "STEM", "Business & Economics"]
  },
  "SUNY Cobleskill": {
    t: 22000, tIn: 8500, h: 12000, m: 5500, f: 1800,
    a: 87,
    r: "Top 40",
    state: "New York",
    majors: ["Agriculture & Environment", "Business & Economics", "STEM"]
  },
  "SUNY Delhi": {
    t: 22000, tIn: 8500, h: 12000, m: 5500, f: 1800,
    a: 82,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "STEM", "Health Sciences"]
  },
  "SUNY Canton": {
    t: 22000, tIn: 8500, h: 12000, m: 5500, f: 1800,
    a: 83,
    r: "Top 40",
    state: "New York",
    majors: ["STEM", "Health Sciences", "Business & Economics"]
  },
  "SUNY Farmingdale": {
    t: 24000, tIn: 8700, h: 13000, m: 5800, f: 1900,
    a: 50,
    r: "Top 40",
    state: "New York",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  },
  "SUNY Empire State College": {
    t: 20000, tIn: 8000, h: 12000, m: 5500, f: 1800,
    a: 80,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "Social Sciences", "Humanities"]
  },
  
  // Additional CUNYs (All New York City public schools)
  "CUNY Lehman College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 45,
    r: "Top 40",
    state: "New York",
    majors: ["Health Sciences", "Education", "Social Sciences"]
  },
  "CUNY John Jay College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 42,
    r: "Top 40",
    state: "New York",
    majors: ["Public Policy & Law", "Social Sciences", "STEM"]
  },
  "CUNY York College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 65,
    r: "Top 40",
    state: "New York",
    majors: ["Health Sciences", "Business & Economics", "STEM"]
  },
  "CUNY Medgar Evers College": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 100,
    r: "Top 40",
    state: "New York",
    majors: ["Health Sciences", "Education", "Business & Economics"]
  },
  "CUNY College of Staten Island": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 100,
    r: "Top 40",
    state: "New York",
    majors: ["Business & Economics", "STEM", "Health Sciences"]
  },
  "CUNY New York City College of Technology": {
    t: 18000, tIn: 7400, h: 14000, m: 6400, f: 2200,
    a: 78,
    r: "Top 40",
    state: "New York",
    majors: ["STEM", "Health Sciences", "Business & Economics"]
  },
  "CUNY Macaulay Honors College": {
    t: 0, tIn: 0, h: 14000, m: 6400, f: 2200,
    a: 8,
    r: "Top 20",
    state: "New York",
    majors: ["Business & Economics", "STEM", "Social Sciences", "Humanities"]
  },
  
  // Other NY Private Schools
  "Fordham University": {
    t: 57000, h: 19000, m: 7400, f: 2900,
    a: 54,
    r: "Top 40",
    majors: ["Business & Economics", "Social Sciences", "Humanities"]
  },
  "St. John's University NY": {
    t: 46000, h: 15500, m: 6700, f: 2400,
    a: 64,
    r: "Top 40",
    majors: ["Business & Economics", "Public Policy & Law", "Health Sciences"]
  },
  "Hofstra University": {
    t: 49000, h: 16000, m: 6800, f: 2500,
    a: 69,
    r: "Top 40",
    majors: ["Business & Economics", "Arts & Media", "Education"]
  },
  "Adelphi University": {
    t: 44000, h: 15000, m: 6600, f: 2400,
    a: 72,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "Social Sciences"]
  },
  "Long Island University Post": {
    t: 42000, h: 14500, m: 6500, f: 2300,
    a: 83,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "Arts & Media"]
  },
  "Long Island University Brooklyn": {
    t: 40000, h: 14500, m: 6500, f: 2300,
    a: 85,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "STEM"]
  },
  "Molloy University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 82,
    r: "Top 40",
    majors: ["Health Sciences", "Education", "Business & Economics"]
  },
  "St. Joseph's University New York": {
    t: 32000, h: 13000, m: 6200, f: 2100,
    a: 73,
    r: "Top 40",
    majors: ["Education", "Business & Economics", "Health Sciences"]
  },
  "Mercy University": {
    t: 36000, h: 13500, m: 6300, f: 2100,
    a: 78,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "Education"]
  },
  "Touro University": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 60,
    r: "Top 40",
    majors: ["Health Sciences", "Business & Economics", "Education"]
  },
  "Yeshiva University": {
    t: 48000, h: 16000, m: 6800, f: 2500,
    a: 62,
    r: "Top 40",
    majors: ["Business & Economics", "Humanities", "STEM"]
  },
  "The New School": {
    t: 52000, h: 18000, m: 7200, f: 2800,
    a: 73,
    r: "Top 40",
    majors: ["Arts & Media", "Social Sciences", "Humanities"]
  },
  "Pratt Institute": {
    t: 54000, h: 17000, m: 6900, f: 2600,
    a: 52,
    r: "Top 40",
    majors: ["Arts & Media", "STEM", "Business & Economics"]
  },
  "School of Visual Arts": {
    t: 46000, h: 17000, m: 6900, f: 2600,
    a: 68,
    r: "Top 40",
    majors: ["Arts & Media", "Business & Economics", "STEM"]
  },
  "Fashion Institute of Technology (FIT)": {
    t: 24000, tIn: 8000, h: 14000, m: 6400, f: 2200,
    a: 45,
    r: "Top 40",
    state: "New York",
    majors: ["Arts & Media", "Business & Economics", "Other"]
  },
  "Parsons School of Design": {
    t: 52000, h: 18000, m: 7200, f: 2800,
    a: 45,
    r: "Top 40",
    state: "New York",
    majors: ["Arts & Media", "Business & Economics", "STEM"]
  },
  "Vassar College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 19,
    r: "Top 20",
    majors: ["Humanities", "Social Sciences", "STEM"]
  },
  "Bard College": {
    t: 58000, h: 17500, m: 7100, f: 2700,
    a: 57,
    r: "Top 40",
    majors: ["Humanities", "Arts & Media", "Social Sciences"]
  },
  "Sarah Lawrence College": {
    t: 60000, h: 18000, m: 7200, f: 2800,
    a: 55,
    r: "Top 40",
    majors: ["Humanities", "Arts & Media", "Social Sciences"]
  },
  "Wagner College": {
    t: 48000, h: 16000, m: 6800, f: 2500,
    a: 80,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Arts & Media"]
  },
  "Le Moyne College": {
    t: 38000, h: 14000, m: 6400, f: 2200,
    a: 70,
    r: "Top 40",
    majors: ["Business & Economics", "Health Sciences", "Education"]
  },
  "Siena College": {
    t: 42000, h: 14500, m: 6500, f: 2300,
    a: 75,
    r: "Top 40",
    majors: ["Business & Economics", "STEM", "Social Sciences"]
  },
  "University at Buffalo SUNY": {
    t: 28000, tIn: 10500, h: 14500, m: 6100, f: 2000,
    a: 68,
    r: "Top 40",
    state: "New York",
    majors: ["STEM", "Business & Economics", "Health Sciences"]
  }
};

export const mockScholarships = [
  // ============================================
  // NEW YORK STATE SCHOLARSHIPS
  // ============================================
  {name: "NY TAP Grant", g: 2.0, sat: 0, state: "New York", a: 5665, u: "https://www.hesc.ny.gov/pay-for-college/apply-for-financial-aid/nys-tap.html", maxIncome: 80000, testOptional: true},
  {name: "NY Excelsior Scholarship", g: 2.5, sat: 0, state: "New York", a: 7500, u: "https://www.hesc.ny.gov/pay-for-college/financial-aid/types-of-financial-aid/nys-grants-scholarships-awards/the-excelsior-scholarship.html", maxIncome: 125000, testOptional: true},
  {name: "NY Enhanced Tuition Award", g: 2.5, sat: 0, state: "New York", a: 6000, u: "https://www.hesc.ny.gov/pay-for-college/financial-aid/types-of-financial-aid/nys-grants-scholarships-awards/enhanced-tuition-awards.html", maxIncome: 125000, testOptional: true},
  {name: "NY STEM Incentive Program", g: 3.0, sat: 0, state: "New York", a: 8000, u: "https://www.hesc.ny.gov/pay-for-college/financial-aid/types-of-financial-aid/nys-grants-scholarships-awards/nys-stem-incentive-program.html", testOptional: true},
  {name: "SUNY Educational Opportunity", g: 2.0, sat: 0, state: "New York", a: 6000, u: "https://www.suny.edu/attend/paying-for-college/financial-aid-by-type/state-grants/eop/", maxIncome: 55000, testOptional: true},
  {name: "NY Community Trust Scholarships", g: 2.5, sat: 0, state: "New York", a: 7500, u: "https://www.nycommunitytrust.org/information-for/for-grantseekers/scholarship-funds/", testOptional: true},
  {name: "Long Island Community Foundation", g: 2.5, sat: 0, state: "New York", a: 5000, u: "https://licf.org/scholarships/", testOptional: true},
  {name: "Rochester Area Foundation", g: 2.5, sat: 0, state: "New York", a: 5000, u: "https://www.racf.org/Grants-Scholarships/Scholarships", testOptional: true},
  
  // ============================================
  // CALIFORNIA STATE SCHOLARSHIPS
  // ============================================
  {name: "Cal Grant A", g: 3.0, sat: 0, state: "California", a: 12570, u: "https://www.csac.ca.gov/cal-grants", maxIncome: 99000, testOptional: true},
  {name: "Cal Grant B", g: 2.0, sat: 0, state: "California", a: 1648, u: "https://www.csac.ca.gov/cal-grants", maxIncome: 55000, testOptional: true},
  {name: "Middle Class Scholarship CA", g: 2.5, sat: 0, state: "California", a: 6000, u: "https://www.csac.ca.gov/middle-class-scholarship", maxIncome: 201000, testOptional: true},
  {name: "California Chafee Grant", g: 2.0, sat: 0, state: "California", a: 5000, u: "https://www.csac.ca.gov/chafee", testOptional: true},
  {name: "Silicon Valley CF Scholarships", g: 2.5, sat: 0, state: "California", a: 5000, u: "https://www.siliconvalleycf.org/scholarships", testOptional: true},
  {name: "LA Community Foundation", g: 2.5, sat: 0, state: "California", a: 4000, u: "https://www.lacf.org/scholarships", testOptional: true},
  {name: "San Diego Foundation", g: 2.5, sat: 0, state: "California", a: 4000, u: "https://www.sdfoundation.org/programs/scholarships/", testOptional: true},
  {name: "Orange County CF Scholarship", g: 2.5, sat: 0, state: "California", a: 4500, u: "https://www.oc-cf.org/scholarships/", testOptional: true},
  
  // ============================================
  // TEXAS STATE SCHOLARSHIPS
  // ============================================
  {name: "Texas TEXAS Grant", g: 2.5, sat: 0, state: "Texas", a: 7500, u: "https://www.thecb.state.tx.us/", maxIncome: 65000, testOptional: true},
  {name: "Texas Top 10% Scholarship", g: 3.5, sat: 0, state: "Texas", a: 8000, u: "https://www.thecb.state.tx.us/", testOptional: true},
  {name: "Texas Tuition Equalization", g: 2.5, sat: 0, state: "Texas", a: 5600, u: "https://www.thecb.state.tx.us/", maxIncome: 70000, testOptional: true},
  {name: "Houston Endowment Scholarship", g: 2.5, sat: 0, state: "Texas", a: 5000, u: "https://www.houstonendowment.org/", testOptional: true},
  {name: "Dallas Foundation Scholarships", g: 2.5, sat: 0, state: "Texas", a: 4000, u: "https://www.dallasfoundation.org/scholarship-program.aspx", testOptional: true},
  {name: "San Antonio Area Foundation", g: 2.5, sat: 0, state: "Texas", a: 3500, u: "https://www.saafdn.org/scholarships", testOptional: true},
  {name: "Austin Community Foundation", g: 2.5, sat: 0, state: "Texas", a: 4000, u: "https://www.austincf.org/scholarships/", testOptional: true},
  
  // ============================================
  // FLORIDA STATE SCHOLARSHIPS
  // ============================================
  {name: "FL Bright Futures Academic", g: 3.5, sat: 1330, state: "Florida", a: 9000, u: "https://www.floridastudentfinancialaidsg.org/SAPBrightFutures/"},
  {name: "FL Bright Futures Medallion", g: 3.0, sat: 1210, state: "Florida", a: 6000, u: "https://www.floridastudentfinancialaidsg.org/SAPBrightFutures/"},
  {name: "Florida Student Assistance", g: 2.0, sat: 0, state: "Florida", a: 3200, u: "https://www.floridastudentfinancialaidsg.org/", maxIncome: 55000, testOptional: true},
  {name: "Miami Foundation Scholarships", g: 2.5, sat: 0, state: "Florida", a: 4000, u: "https://miamifoundation.org/scholarships/", testOptional: true},
  {name: "Jacksonville Community Foundation", g: 2.5, sat: 0, state: "Florida", a: 3500, u: "https://www.jaxcf.org/scholarships", testOptional: true},
  {name: "Tampa Bay Foundation", g: 2.5, sat: 0, state: "Florida", a: 3500, u: "https://www.cftampabay.org/scholarships/", testOptional: true},
  
  // ============================================
  // PENNSYLVANIA SCHOLARSHIPS
  // ============================================
  {name: "PA State Grant Program", g: 2.0, sat: 0, state: "Pennsylvania", a: 4500, u: "https://www.pheaa.org/funding-opportunities/state-grant-program/", maxIncome: 80000, testOptional: true},
  {name: "Pittsburgh Foundation", g: 2.5, sat: 0, state: "Pennsylvania", a: 4000, u: "https://pittsburghfoundation.org/scholarships", testOptional: true},
  {name: "Philadelphia Foundation", g: 2.5, sat: 0, state: "Pennsylvania", a: 4000, u: "https://www.philafound.org/scholarships/", testOptional: true},
  {name: "Lehigh Valley CF Scholarship", g: 2.5, sat: 0, state: "Pennsylvania", a: 3500, u: "https://www.lvcf.org/scholarships/", testOptional: true},
  
  // ============================================
  // NEW JERSEY SCHOLARSHIPS
  // ============================================
  {name: "NJ Tuition Aid Grant", g: 2.0, sat: 0, state: "New Jersey", a: 13000, u: "https://www.hesaa.org/Pages/NJTuitionAidGrant.aspx", maxIncome: 80000, testOptional: true},
  {name: "NJ STARS Scholarship", g: 3.25, sat: 0, state: "New Jersey", a: 6000, u: "https://www.hesaa.org/Pages/NJSTARS.aspx", testOptional: true},
  {name: "Community Foundation NJ", g: 2.5, sat: 0, state: "New Jersey", a: 4000, u: "https://cfnj.org/scholarships/", testOptional: true},
  
  // ============================================
  // ILLINOIS SCHOLARSHIPS
  // ============================================
  {name: "Illinois MAP Grant", g: 2.0, sat: 0, state: "Illinois", a: 5000, u: "https://www.isac.org/students/during-college/types-of-financial-aid/grants/map/", maxIncome: 65000, testOptional: true},
  {name: "Illinois AIM HIGH Grant", g: 3.0, sat: 0, state: "Illinois", a: 4000, u: "https://www.isac.org/students/during-college/types-of-financial-aid/grants/aim-high/", testOptional: true},
  {name: "Chicago Community Trust", g: 2.5, sat: 0, state: "Illinois", a: 5000, u: "https://www.cct.org/our-scholarships/", testOptional: true},
  
  // ============================================
  // OHIO SCHOLARSHIPS
  // ============================================
  {name: "Ohio College Opportunity", g: 2.0, sat: 0, state: "Ohio", a: 3000, u: "https://www.ohiohighered.org/ocog", maxIncome: 60000, testOptional: true},
  {name: "Cleveland Foundation", g: 2.5, sat: 0, state: "Ohio", a: 4000, u: "https://www.clevelandfoundation.org/grants-scholarships/", testOptional: true},
  {name: "Columbus Foundation", g: 2.5, sat: 0, state: "Ohio", a: 4000, u: "https://columbusfoundation.org/scholarships", testOptional: true},
  {name: "Cincinnati Foundation", g: 2.5, sat: 0, state: "Ohio", a: 3500, u: "https://www.gcfdn.org/scholarships/", testOptional: true},
  
  // ============================================
  // GEORGIA SCHOLARSHIPS
  // ============================================
  {name: "Georgia HOPE Scholarship", g: 3.0, sat: 0, state: "Georgia", a: 7000, u: "https://gsfc.georgia.gov/hope", testOptional: true},
  {name: "Georgia Zell Miller", g: 3.7, sat: 1200, state: "Georgia", a: 9000, u: "https://gsfc.georgia.gov/zell-miller"},
  {name: "Atlanta Community Foundation", g: 2.5, sat: 0, state: "Georgia", a: 4000, u: "https://www.cfgreateratlanta.org/scholarships/", testOptional: true},
  
  // ============================================
  // MICHIGAN SCHOLARSHIPS
  // ============================================
  {name: "Michigan Tuition Grant", g: 2.5, sat: 0, state: "Michigan", a: 2800, u: "https://www.michigan.gov/mistudentaid/", maxIncome: 60000, testOptional: true},
  {name: "Michigan Competitive", g: 2.5, sat: 0, state: "Michigan", a: 1500, u: "https://www.michigan.gov/mistudentaid/", testOptional: true},
  {name: "Detroit Community Foundation", g: 2.5, sat: 0, state: "Michigan", a: 4000, u: "https://cfsem.org/scholarships/", testOptional: true},
  {name: "Grand Rapids CF Scholarship", g: 2.5, sat: 0, state: "Michigan", a: 3500, u: "https://www.grfoundation.org/scholarships", testOptional: true},
  
  // ============================================
  // NORTH CAROLINA SCHOLARSHIPS
  // ============================================
  {name: "NC Education Lottery", g: 2.5, sat: 0, state: "North Carolina", a: 5500, u: "https://www.cfnc.org/pay-for-college/", maxIncome: 80000, testOptional: true},
  {name: "NC Need-Based Scholarship", g: 2.0, sat: 0, state: "North Carolina", a: 4000, u: "https://www.cfnc.org/pay-for-college/", maxIncome: 55000, testOptional: true},
  {name: "Charlotte Foundation", g: 2.5, sat: 0, state: "North Carolina", a: 3500, u: "https://www.fftc.org/scholarships", testOptional: true},
  
  // ============================================
  // VIRGINIA SCHOLARSHIPS
  // ============================================
  {name: "Virginia Tuition Assistance", g: 2.5, sat: 0, state: "Virginia", a: 4000, u: "https://www.schev.edu/students/", testOptional: true},
  {name: "Virginia Commonwealth Award", g: 2.0, sat: 0, state: "Virginia", a: 3000, u: "https://www.schev.edu/students/", maxIncome: 65000, testOptional: true},
  {name: "Greater Richmond CF", g: 2.5, sat: 0, state: "Virginia", a: 3500, u: "https://www.cfrichmond.org/scholarships/", testOptional: true},
  
  // ============================================
  // WASHINGTON STATE SCHOLARSHIPS
  // ============================================
  {name: "Washington College Grant", g: 2.0, sat: 0, state: "Washington", a: 11400, u: "https://wsac.wa.gov/washington-college-grant", maxIncome: 74000, testOptional: true},
  {name: "Seattle Foundation", g: 2.5, sat: 0, state: "Washington", a: 4000, u: "https://www.seattlefoundation.org/nonprofitresources/scholarships", testOptional: true},
  
  // ============================================
  // MASSACHUSETTS SCHOLARSHIPS
  // ============================================
  {name: "MASSGrant", g: 2.0, sat: 0, state: "Massachusetts", a: 2300, u: "https://www.mass.edu/osfa/programs/massgrant.asp", maxIncome: 60000, testOptional: true},
  {name: "Boston Foundation", g: 2.5, sat: 0, state: "Massachusetts", a: 5000, u: "https://www.tbf.org/what-we-do/scholarships", testOptional: true},
  
  // ============================================
  // CONNECTICUT SCHOLARSHIPS
  // ============================================
  {name: "CT Public College Aid", g: 2.0, sat: 0, state: "Connecticut", a: 4650, u: "https://www.ctohe.org/sfa/default.shtml", maxIncome: 75000, testOptional: true},
  {name: "Hartford Foundation", g: 2.5, sat: 0, state: "Connecticut", a: 4000, u: "https://www.hfpg.org/scholarships", testOptional: true},
  
  // ============================================
  // COLORADO SCHOLARSHIPS
  // ============================================
  {name: "Colorado Student Grant", g: 2.5, sat: 0, state: "Colorado", a: 5000, u: "https://cdhe.colorado.gov/students/preparing-for-college/colorado-student-grant", maxIncome: 70000, testOptional: true},
  {name: "Denver Foundation", g: 2.5, sat: 0, state: "Colorado", a: 4000, u: "https://www.denverfoundation.org/scholarships/", testOptional: true},
  
  // ============================================
  // ARIZONA SCHOLARSHIPS
  // ============================================
  {name: "AZ Leveraging Assistance", g: 2.5, sat: 0, state: "Arizona", a: 2500, u: "https://azgrants.gov/", maxIncome: 55000, testOptional: true},
  {name: "Arizona Community Foundation", g: 2.5, sat: 0, state: "Arizona", a: 3500, u: "https://www.azfoundation.org/scholarships/", testOptional: true},
  
  // ============================================
  // MINNESOTA SCHOLARSHIPS
  // ============================================
  {name: "Minnesota State Grant", g: 2.0, sat: 0, state: "Minnesota", a: 6000, u: "https://www.ohe.state.mn.us/", maxIncome: 70000, testOptional: true},
  {name: "Minneapolis Foundation", g: 2.5, sat: 0, state: "Minnesota", a: 4000, u: "https://www.minneapolisfoundation.org/scholarships/", testOptional: true},
  
  // ============================================
  // WISCONSIN SCHOLARSHIPS
  // ============================================
  {name: "Wisconsin Grant", g: 2.5, sat: 0, state: "Wisconsin", a: 3000, u: "https://heab.wisconsin.gov/", maxIncome: 60000, testOptional: true},
  {name: "Greater Milwaukee Foundation", g: 2.5, sat: 0, state: "Wisconsin", a: 3500, u: "https://www.greatermilwaukeefoundation.org/scholarships/", testOptional: true},
  
  // ============================================
  // INDIANA SCHOLARSHIPS
  // ============================================
  {name: "Indiana Frank O'Bannon", g: 2.5, sat: 0, state: "Indiana", a: 5500, u: "https://www.in.gov/che/state-financial-aid/", maxIncome: 70000, testOptional: true},
  {name: "21st Century Scholars", g: 2.5, sat: 0, state: "Indiana", a: 8000, u: "https://scholars.in.gov/", maxIncome: 50000, testOptional: true},
  {name: "Indianapolis Foundation", g: 2.5, sat: 0, state: "Indiana", a: 3500, u: "https://www.cicf.org/scholarships/", testOptional: true},
  
  // ============================================
  // MISSOURI SCHOLARSHIPS
  // ============================================
  {name: "Missouri Access Grant", g: 2.5, sat: 0, state: "Missouri", a: 3000, u: "https://dhewd.mo.gov/", maxIncome: 55000, testOptional: true},
  {name: "St. Louis Community Foundation", g: 2.5, sat: 0, state: "Missouri", a: 3500, u: "https://www.stlgives.org/scholarships/", testOptional: true},
  
  // ============================================
  // TENNESSEE SCHOLARSHIPS
  // ============================================
  {name: "TN HOPE Scholarship", g: 3.0, sat: 0, state: "Tennessee", a: 5400, u: "https://www.tn.gov/collegepays/money-for-college/tn-education-lottery-programs/tennessee-hope-scholarship.html", testOptional: true},
  {name: "Tennessee Promise", g: 2.0, sat: 0, state: "Tennessee", a: 3000, u: "https://www.tnpromise.gov/", testOptional: true},
  {name: "Nashville Community Foundation", g: 2.5, sat: 0, state: "Tennessee", a: 3500, u: "https://www.cfmt.org/scholarships/", testOptional: true},
  
  // ============================================
  // MARYLAND SCHOLARSHIPS
  // ============================================
  {name: "MD Howard P. Rawlings", g: 2.5, sat: 0, state: "Maryland", a: 3000, u: "https://mhec.maryland.gov/preparing/Pages/FinancialAid/ProgramDescriptions/prog_rawlings.aspx", maxIncome: 65000, testOptional: true},
  {name: "Baltimore Community Foundation", g: 2.5, sat: 0, state: "Maryland", a: 3500, u: "https://www.bcf.org/scholarships/", testOptional: true},
  
  // ============================================
  // OREGON SCHOLARSHIPS
  // ============================================
  {name: "Oregon Opportunity Grant", g: 2.5, sat: 0, state: "Oregon", a: 3600, u: "https://oregonstudentaid.gov/", maxIncome: 60000, testOptional: true},
  {name: "Oregon Community Foundation", g: 2.5, sat: 0, state: "Oregon", a: 4000, u: "https://oregoncf.org/scholarships/", testOptional: true},
  
  // ============================================
  // KENTUCKY SCHOLARSHIPS
  // ============================================
  {name: "KY College Access Program", g: 2.5, sat: 0, state: "Kentucky", a: 2600, u: "https://www.kheaa.com/", maxIncome: 55000, testOptional: true},
  {name: "Kentucky Tuition Grant", g: 2.5, sat: 0, state: "Kentucky", a: 3000, u: "https://www.kheaa.com/", testOptional: true},
  
  // ============================================
  // SOUTH CAROLINA SCHOLARSHIPS
  // ============================================
  {name: "SC LIFE Scholarship", g: 3.0, sat: 0, state: "South Carolina", a: 5000, u: "https://www.che.sc.gov/", testOptional: true},
  {name: "SC Palmetto Fellows", g: 3.5, sat: 1200, state: "South Carolina", a: 6700, u: "https://www.che.sc.gov/"},
  
  // ============================================
  // ALABAMA SCHOLARSHIPS
  // ============================================
  {name: "Alabama Student Assistance", g: 2.5, sat: 0, state: "Alabama", a: 2500, u: "https://ache.edu/", maxIncome: 55000, testOptional: true},
  {name: "Community Foundation Birmingham", g: 2.5, sat: 0, state: "Alabama", a: 3000, u: "https://www.cfbham.org/scholarships/", testOptional: true},
  
  // ============================================
  // LOUISIANA SCHOLARSHIPS
  // ============================================
  {name: "LA TOPS Award", g: 2.5, sat: 0, state: "Louisiana", a: 6000, u: "https://mylosfa.la.gov/", testOptional: true},
  {name: "Louisiana GO Grant", g: 2.0, sat: 0, state: "Louisiana", a: 3000, u: "https://mylosfa.la.gov/", maxIncome: 55000, testOptional: true},
  
  // ============================================
  // NATIONAL SCHOLARSHIPS - MERIT BASED
  // ============================================
  {name: "Coca-Cola Scholars", g: 3.0, sat: 0, state: "any", a: 20000, u: "https://www.coca-colascholarsfoundation.org/", testOptional: true},
  {name: "Burger King Scholarship", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://bkmclamorefoundation.org/scholarship/", testOptional: true},
  {name: "Jack Kent Cooke Foundation", g: 3.5, sat: 0, state: "any", a: 55000, u: "https://www.jkcf.org/our-scholarships/", maxIncome: 95000, testOptional: true},
  {name: "Gates Scholarship", g: 3.3, sat: 0, state: "any", a: 50000, u: "https://www.thegatesscholarship.org/", maxIncome: 60000, testOptional: true},
  {name: "Regeneron STS", g: 3.5, sat: 0, state: "any", a: 250000, u: "https://www.societyforscience.org/regeneron-sts/", testOptional: true},
  {name: "Cameron Impact Scholarship", g: 3.7, sat: 0, state: "any", a: 50000, u: "https://www.bryancameroneducationfoundation.org/", testOptional: true},
  {name: "Questbridge Scholar", g: 3.5, sat: 0, state: "any", a: 75000, u: "https://www.questbridge.org/", maxIncome: 65000, testOptional: true},
  
  // ============================================
  // NATIONAL SCHOLARSHIPS - ACCESSIBLE
  // ============================================
  {name: "Niche No Essay Scholarship", g: 2.0, sat: 0, state: "any", a: 2000, u: "https://www.niche.com/colleges/scholarship/no-essay-scholarship", testOptional: true},
  {name: "Bold.org Scholarships", g: 2.0, sat: 0, state: "any", a: 5000, u: "https://bold.org/scholarships/", testOptional: true},
  {name: "Unigo $10K Scholarship", g: 2.0, sat: 0, state: "any", a: 10000, u: "https://www.unigo.com/scholarships/", testOptional: true},
  {name: "Dr Pepper Tuition Giveaway", g: 2.0, sat: 0, state: "any", a: 25000, u: "https://www.drpeppertuition.com/", testOptional: true},
  {name: "Discover Student Scholarship", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://www.discover.com/student-loans/scholarships/", testOptional: true},
  {name: "Scholarships.com Monthly", g: 2.0, sat: 0, state: "any", a: 1000, u: "https://www.scholarships.com/", testOptional: true},
  {name: "Cappex Easy Money", g: 2.0, sat: 0, state: "any", a: 1000, u: "https://www.cappex.com/scholarships", testOptional: true},
  {name: "ScholarshipOwl", g: 2.0, sat: 0, state: "any", a: 1000, u: "https://scholarshipowl.com/", testOptional: true},
  {name: "Fastweb", g: 2.0, sat: 0, state: "any", a: 1000, u: "https://www.fastweb.com/", testOptional: true},
  
  // ============================================
  // NATIONAL SCHOLARSHIPS - NEED BASED
  // ============================================
  {name: "Dell Scholars Program", g: 2.4, sat: 0, state: "any", a: 20000, u: "https://www.dellscholars.org/", maxIncome: 65000, testOptional: true},
  {name: "Horatio Alger Scholarship", g: 2.0, sat: 0, state: "any", a: 25000, u: "https://scholars.horatioalger.org/", maxIncome: 55000, testOptional: true},
  {name: "Elks National Foundation", g: 2.5, sat: 0, state: "any", a: 12500, u: "https://www.elks.org/scholars/", maxIncome: 65000, testOptional: true},
  {name: "KFC Foundation Grant", g: 2.5, sat: 0, state: "any", a: 20000, u: "https://www.kfc.com/about/kfc-foundation", testOptional: true},
  {name: "Taco Bell Live Mas", g: 2.0, sat: 0, state: "any", a: 10000, u: "https://www.livemasscholarship.com/", testOptional: true},
  {name: "Dream.US Scholarship", g: 2.5, sat: 0, state: "any", a: 33000, u: "https://www.thedream.us/scholarships/", maxIncome: 60000, testOptional: true},
  {name: "Foot Locker Foundation", g: 3.0, sat: 0, state: "any", a: 20000, u: "https://www.footlocker.com/scholarship", testOptional: true},
  
  // ============================================
  // STEM SCHOLARSHIPS
  // ============================================
  {name: "Barry Goldwater Scholarship", g: 3.5, sat: 0, state: "any", a: 7500, u: "https://goldwaterscholarship.gov/", testOptional: true},
  {name: "Society of Women Engineers", g: 3.0, sat: 0, state: "any", a: 10000, u: "https://swe.org/scholarships/", testOptional: true},
  {name: "AFCEA STEM Scholarship", g: 3.0, sat: 0, state: "any", a: 5000, u: "https://www.afcea.org/education-stem/scholarships", testOptional: true},
  {name: "Generation Google Scholarship", g: 3.0, sat: 0, state: "any", a: 10000, u: "https://buildyourfuture.withgoogle.com/scholarships", testOptional: true},
  {name: "Microsoft Scholarship", g: 3.0, sat: 0, state: "any", a: 5000, u: "https://careers.microsoft.com/students/scholarships", testOptional: true},
  {name: "Amazon Future Engineer", g: 3.0, sat: 0, state: "any", a: 40000, u: "https://www.amazonfutureengineer.com/scholarships", testOptional: true},
  {name: "NSBE Scholarship", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://connect.nsbe.org/Scholarships/", testOptional: true},
  {name: "SHPE Foundation Scholarship", g: 3.0, sat: 0, state: "any", a: 5000, u: "https://shpe.org/students/scholarships/", testOptional: true},
  
  // ============================================
  // HEALTHCARE SCHOLARSHIPS
  // ============================================
  {name: "AAMC Scholarships", g: 3.0, sat: 0, state: "any", a: 10000, u: "https://www.aamc.org/services/first-generation/scholarships", testOptional: true},
  {name: "AACN Nursing Scholarship", g: 3.0, sat: 0, state: "any", a: 5000, u: "https://www.aacnnursing.org/Students/Financial-Aid", testOptional: true},
  {name: "HOSA Future Health", g: 2.5, sat: 0, state: "any", a: 3000, u: "https://hosa.org/scholarships/", testOptional: true},
  
  // ============================================
  // DIVERSITY SCHOLARSHIPS
  // ============================================
  {name: "Hispanic Scholarship Fund", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://www.hsf.net/scholarship", testOptional: true},
  {name: "UNCF Scholarship", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://scholarships.uncf.org/", maxIncome: 65000, testOptional: true},
  {name: "APIA Scholarship", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://www.apiascholars.org/scholarship/apia-scholarship/", testOptional: true},
  {name: "American Indian College Fund", g: 2.0, sat: 0, state: "any", a: 3000, u: "https://collegefund.org/students/scholarships/", testOptional: true},
  {name: "Point Foundation LGBTQ", g: 2.5, sat: 0, state: "any", a: 10000, u: "https://pointfoundation.org/point-apply/", testOptional: true},
  {name: "NAACP Scholarships", g: 2.5, sat: 0, state: "any", a: 3000, u: "https://naacp.org/find-resources/scholarships-awards-internships", testOptional: true},
  {name: "LULAC National Scholarship", g: 3.0, sat: 0, state: "any", a: 2000, u: "https://lnesc.org/scholarships/", testOptional: true},
  {name: "Jackie Robinson Foundation", g: 3.0, sat: 0, state: "any", a: 30000, u: "https://www.jackierobinson.org/apply/", maxIncome: 60000, testOptional: true},
  {name: "Thurgood Marshall Scholarship", g: 3.0, sat: 0, state: "any", a: 6000, u: "https://tmcf.org/students-alumni/scholarships/", testOptional: true},
  {name: "Asian Women in Business", g: 3.0, sat: 0, state: "any", a: 5000, u: "https://awib.org/index.cfm?fuseaction=Page.viewPage&pageId=811", testOptional: true},
  
  // ============================================
  // FIRST-GENERATION SCHOLARSHIPS
  // ============================================
  {name: "First in Family Scholarship", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://americanhumanist.org/what-is-humanism/first-family-humanist-scholarship/", testOptional: true},
  {name: "I'm First! Scholarship", g: 2.5, sat: 0, state: "any", a: 40000, u: "https://imfirst.org/", maxIncome: 60000, testOptional: true},
  {name: "CFNC First Generation", g: 2.5, sat: 0, state: "any", a: 3000, u: "https://www.cfnc.org/pay-for-college/", testOptional: true},
  
  // ============================================
  // COMMUNITY SERVICE SCHOLARSHIPS
  // ============================================
  {name: "Prudential Spirit of Community", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://spirit.prudential.com/", testOptional: true},
  {name: "AXA Achievement Scholarship", g: 3.0, sat: 0, state: "any", a: 10000, u: "https://us.axa.com/axa-foundation/community-scholarship.html", testOptional: true},
  {name: "Newman Civic Fellowship", g: 3.0, sat: 0, state: "any", a: 5000, u: "https://compact.org/newman-civic-fellowship/", testOptional: true},
  {name: "Bonner Scholars Program", g: 2.5, sat: 0, state: "any", a: 6000, u: "https://bonner.org/apply", testOptional: true},
  
  // ============================================
  // MILITARY/VETERAN SCHOLARSHIPS
  // ============================================
  {name: "Pat Tillman Foundation", g: 3.0, sat: 0, state: "any", a: 10000, u: "https://pattillmanfoundation.org/tillman-scholars/", testOptional: true},
  {name: "AMVETS Scholarships", g: 2.5, sat: 0, state: "any", a: 4000, u: "https://amvets.org/scholarships/", testOptional: true},
  {name: "Fisher House Scholarship", g: 2.5, sat: 0, state: "any", a: 5000, u: "https://www.fisherhouse.org/programs/scholarship-programs/", testOptional: true},
  
  // ============================================
  // DISABILITIES SCHOLARSHIPS
  // ============================================
  {name: "Lime Connect Scholarship", g: 3.0, sat: 0, state: "any", a: 10000, u: "https://www.limeconnect.com/scholarships/", testOptional: true},
  {name: "Anne Ford Scholarship", g: 3.0, sat: 0, state: "any", a: 10000, u: "https://ncld.org/scholarships/", testOptional: true},
  {name: "DisABLEDperson Scholarship", g: 2.5, sat: 0, state: "any", a: 2000, u: "https://www.disabledperson.com/scholarships", testOptional: true},
  
  // ============================================
  // ARTS & HUMANITIES SCHOLARSHIPS
  // ============================================
  {name: "National YoungArts Foundation", g: 2.5, sat: 0, state: "any", a: 10000, u: "https://www.youngarts.org/", testOptional: true},
  {name: "Scholastic Art & Writing", g: 2.5, sat: 0, state: "any", a: 10000, u: "https://www.artandwriting.org/scholarships/", testOptional: true},
  {name: "Davidson Fellows Scholarship", g: 3.5, sat: 0, state: "any", a: 50000, u: "https://www.davidsongifted.org/gifted-programs/fellows-scholarship/", testOptional: true}
];


// Cost and health calculation functions
export const calculateNetCost = (college, income, scholarships, grants, loans, savings) => {
  const total = college.t + college.h + college.m + college.f;
  const aidTotal = scholarships + grants;
  const netAnnual = Math.max(0, total - aidTotal);
  const netFourYear = netAnnual * 4;
  const afterSavings = Math.max(0, netFourYear - savings);
  return { netAnnual, netFourYear, afterSavings, total };
};

export const calculateHealthScore = (annualCost, income) => {
  const ratio = (annualCost / income) * 100;
  if (ratio <= 20) return { status: "Healthy", ratio: ratio.toFixed(1) };
  if (ratio <= 35) return { status: "Moderate Risk", ratio: ratio.toFixed(1) };
  return { status: "High Risk", ratio: ratio.toFixed(1) };
};

// Helper to get the category for a specific major
export const getMajorCategory = (specificMajor) => {
  for (const [category, majors] of Object.entries(majorCategories)) {
    if (majors.includes(specificMajor)) {
      return category;
    }
  }
  return null;
};

// Map new category names to old college major names
const categoryMapping = {
  "Business": "Business & Economics",
  "STEM": "STEM",
  "Law & Public Policy": "Public Policy & Law",
  "Arts & Humanities": ["Humanities", "Arts & Media", "Social Sciences"],
  "Health & Medicine": "Health Sciences",
  "Other": ["Education", "Agriculture & Environment", "Social Sciences"]
};

export const findAlternatives = (selectedCollege, selectedMajor, healthStatus) => {
  // Always show alternatives
  
  const selected = mockColleges[selectedCollege];
  if (!selected) return [];
  
  // Get the category for the selected major
  const majorCategory = getMajorCategory(selectedMajor);
  
  // Get the college major names to match against
  const collegeMajorsToMatch = [];
  if (majorCategory && categoryMapping[majorCategory]) {
    const mapped = categoryMapping[majorCategory];
    if (Array.isArray(mapped)) {
      collegeMajorsToMatch.push(...mapped);
    } else {
      collegeMajorsToMatch.push(mapped);
    }
  }
  
  const alternatives = [];
  
  const getRankingGroup = (ranking) => {
    if (ranking === "Top 10") return 1;
    if (ranking === "Top 20") return 2;
    if (ranking === "Top 30") return 3;
    if (ranking === "Top 40") return 4;
    return 5;
  };
  
  const selectedGroup = getRankingGroup(selected.r);
  const selectedCost = selected.t + selected.h + selected.m + selected.f;
  
  for (const [name, data] of Object.entries(mockColleges)) {
    if (name === selectedCollege) continue;
    
    const collegeCost = data.t + data.h + data.m + data.f;
    
    if (Math.abs(data.a - selected.a) > 15) continue;
    
    const altGroup = getRankingGroup(data.r);
    if (Math.abs(altGroup - selectedGroup) > 1) continue;
    
    if (collegeMajorsToMatch.length > 0) {
      const hasMatchingMajor = data.majors.some(m => collegeMajorsToMatch.includes(m));
      if (!hasMatchingMajor) continue;
    }
    
    alternatives.push({
      name,
      cost: collegeCost,
      savings: selectedCost - collegeCost,
      acceptanceRate: data.a,
      ranking: data.r
    });
  }
  
  return alternatives.sort((a, b) => b.savings - a.savings).slice(0, 5);
};

// Filter scholarships based on user criteria
export const filterScholarships = (gpa, sat, state, income, testOptional = false) => {
  return mockScholarships.filter(s => {
    if (gpa < s.g) return false;
    if (!testOptional && s.sat > 0 && sat < s.sat) return false;
    if (testOptional && !s.testOptional && s.sat > 0) return false;
    if (s.state !== "any" && s.state !== state) return false;
    if (s.maxIncome && income > s.maxIncome) return false;
    return true;
  });
};

